/** * @description: 工单管理 => 录单form * @author */
<template>
  <div class="record-sheet-form">
    <!-- 电话条 -->
    <component
      v-if="isTelephoneBar"
      :is="softPhoneObj.telephoneType === 1 ? 'jms-softphone' : 'mi-softphone'"
      :ref="isStPhone ? 'soft' : 'miSoft'"
      style="margin-bottom: 12px"
      :extno="softPhoneObj.seatExtensionNumber"
      :queue="softPhoneObj.stSkillGroup"
      @changeWaybill="changeWaybill"
      @changePhone="changePhone"
      @talkEnd="talkEnd"
    />
    <service-form
      :option="option"
      v-model="formData"
      ref="form"
      @submit="saveSubmit"
      @beforeSubmit="beforeSubmit"
      :loading="loading"
      class="bs-service leftform-customer-type"
    >
      <!-- 在运单号后面的按钮icon -->
      <!-- <template slot="waybillNoTipTwo"> -->
        <!-- 网点信息 -->
        <!-- <DotInformation
          :waybillNo="formData.waybillNo"
          :customerExcList="customerExcList"
        />
      </template> -->

      <!-- 在运单号后面的icon -->
      <!-- <template slot="waybillNoTip"> -->
        <!-- 网点信息 -->
        <!-- <abnomal-tip ref="abnomalTip" :waybillNo="this.formData.waybillNo" />
      </template> -->
      <template slot="customerPhone">
        <el-row>
          <el-col :span="9" class="customer-phone">
            <el-input
              placeholder="请输入内容"
              v-model="formData.customerPhone"
              :disabled="isCustomerPhoneDisabled"
              @input="changeInputPhone"
              class="input-with-select"
              maxlength="15"
              @blur="clearCustomerPhone"
              @focus="handlePhoneFocus"

            />
            <span type="text" class="search-btn" @click="searchFn">{{
              $lang("查询")
            }}</span>
            <el-button
              v-if="isService&&tikTokReverse"
              style="margin-left:5px;font-size: 12px;"
              type="primary"
              size="mini"
              @click="intoCustomerPhone"
            >自动带入</el-button>
          </el-col>
          <el-col :span="2">
            <span v-if="softPhoneObj.telephoneType === 1">
              <el-tooltip
                :content="$lang('来电次数')"
                :placement="'top'"
                v-show="!(customerNum === '')"
              >
                <span class="customer-num">{{ customerNum }}</span>
              </el-tooltip>
            </span>
          </el-col>
          <el-col :span="13">
            <span v-if="customerTagList.length && formData.customerPhone">
              <el-tag
                type="danger"
                size="mini"
                v-for="(item, index) in customerTagList"
                :key="index"
                style="margin-right: 4px"
                >{{ item }}</el-tag
              >
            </span>
          </el-col>
        </el-row>
      </template>
      <!-- 收件人地址 -->
      <template slot="receiverAreaId">
        <address-select
          v-model="addressInitData"
          :disabled="(isUpgrade || isDisabledAddress) && !formData.isProject"
          @changeValue="changeAddress"
        />
      </template>
      <!-- 客户地址 -->
      <template slot="typeReceiverProvinceName">
        <address-select v-model="typeReceiver" :disabled="isUpgrade" @changeValue="typeReceiverAddressHandler" />
      </template>
      <!-- 客户地址 -->
      <template slot="address">
        <address-select
          v-model="customerAddressData"
          :disabled="!ifTransferOrder"
          @changeValue="customerAddressHandler"
        />
      </template>
      <!-- 运单标签 -->
      <template slot="waybillTag">
        <WaybillTagContent :waybillNo="formData.waybillNo" />
      </template>
      <template slot="firstType">
        <first-type-select
          v-model="formData.firstType"
          :list="firstTypeList"
          :isDisabledAll="isUpgrade || aiLost"
          @change="changeFirstType"
        />
      </template>
      <template slot="secondTypeId">
        <div>
          <first-type-select
            v-model="formData.secondTypeId"
            :list="secondTypeList"
            :isDisabledAll="isUpgrade || aiLost"
            @change="changeSecondType(formData.secondTypeId, true,'',true)"
          />
        </div>
      </template>
      <template slot="orderForm">
        <order-info-form ref="orderInfoForm" v-show="isPlaceOrder" />
      </template>
      <template slot="handlingOpinions">
        <!-- 当状态为关闭、暂不处理、催单时才展示工单话术 -->
        <div
          v-if="
            questionList.length &&
            (formData.processingMode === 1 ||
              formData.reminderMode === 2 ||
              formData.reminderMode === 1)
          "
          class="project-process-question"
        >
          <div
            class="q-list"
            @click="selectQuestion(item.id)"
            :class="item.isChecked ? 'active' : ''"
            v-for="item in questionList"
            :key="item.id"
          >
            <el-tooltip class="item" effect="dark" :content="item.scene" placement="top">
              <span>{{ item.scene }}</span>
            </el-tooltip>
            <i class="el-icon-success" v-if="item.isChecked"></i>
          </div>
        </div>
        <div class="area">
          <el-input
            type="textarea"
            placeholder="请输入"
            v-model="formData.handlingOpinions"
            maxlength="500"
            :rows="4"
            show-word-limit
            @input="changeOpinion"
          ></el-input>
        </div>
      </template>
      <template slot="mode" v-if="restartOrder">
        <el-radio-group v-model="formData.processingMode" @input="changeProcessingMode">
          <el-radio :label="1">{{ $lang("关闭") }}</el-radio>
          <el-radio :disabled="modeDisabled || defaultGroup === 1" :label="2">{{
            $lang("重启工单")
          }}</el-radio>
        </el-radio-group>
      </template>
      <template slot="mode" v-else>
        <el-radio-group
          v-model="formData.processingMode"
          v-if="[1, 2, 3, 4, 5, 9].includes(defaultGroup)"
          @input="changeProcessingMode"
        >
          <el-radio :label="1">{{ $lang("关闭") }}</el-radio>
          <el-radio :label="2" :disabled="modeDisabled || defaultGroup === 1">{{
            $lang("转单")
          }}</el-radio>
        </el-radio-group>
        <el-radio-group
          v-model="formData.reminderMode"
          v-if="[6, 7, 8].includes(defaultGroup)"
          @change="handleChangeGroupTypeNew"
        >
          <el-radio :label="reminderModeMap.NOT_HANDLE">{{ $lang("暂不处理") }}</el-radio>
          <el-radio :label="reminderModeMap.REMINDER">{{ $lang("催单") }}</el-radio>
          <el-radio :label="reminderModeMap.UPGRADE" :disabled="defaultGroup !== 8">{{
            $lang("升级")
          }}</el-radio>
        </el-radio-group>
      </template>
      <template slot="groupType" v-if="formData.processingMode === 2">
        <el-radio-group v-model="formData.groupType" @change="handleChangeGroupType">
          <el-radio :label="1" :disabled="isHqVip || isVisit || formData.supportTransferToHeadQuarters">{{ $lang("网点组") }}</el-radio>
          <el-radio :label="2" :disabled="isHqVip || isVisit || formData.supportTransferToHeadQuarters">{{ $lang("代理组") }}</el-radio>
          <el-radio
            :label="3"
            :disabled="!isHQ || isHqVip || formData.secondTypeCode === '2012'"
            >{{ $lang("总部组") }}</el-radio
          >
          <el-radio
            :label="4"
            :disabled="!isHQ || formData.memberType === 2"
            v-if="hqVip"
            >{{ $lang("总部VIP组") }}</el-radio
          >
        </el-radio-group>
        <br v-if="formData.groupType === 3" />
        <el-radio-group
          v-model="formData.centerGroupType"
          v-if="formData.groupType === 3"
          class="line-radio"
        >
          <el-radio :label="1">{{ $lang("总部工单组") }}</el-radio>
          <!-- <el-radio :label="2">{{ $lang("总部理赔组") }}</el-radio> -->
          <!-- <el-radio
            :label="3"
            v-if="defaultGroup === 9"
          >{{ $lang('新JT工单组') }}</el-radio> -->
        </el-radio-group>
      </template>
      <template slot="groupType" v-else-if="formData.reminderMode === 3">
        <el-radio-group v-model="formData.reminderModeType" @change="handleChangeReminderModeType">
          <el-radio :label="2" v-if="[335,336].includes(formData.upgradeNetworkTypeId)">{{ $lang("代理组") }}</el-radio>
          <el-radio :label="3">{{ $lang("总部组") }}</el-radio>
        </el-radio-group>
      </template>
      <template slot="networkId">
        <el-select
          v-if="
            [1, 2, 3, 4, 5, 9].includes(defaultGroup) && formData.processingMode !== 1
          "
          style="width: 200px"
          v-model="formData.networkId"
          @change="changeNetwork"
          filterable
          clearable
          :placeholder="$lang('请选择网点')"
        >
          <el-option
            v-for="item in networkOptions"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
        <el-input v-else-if="defaultGroup === 8" disabled :value="upgradeNetwork" />
      </template>
      <template slot="menuFormFront">
         <!-- 收货偏好 -->
        <ShippingPreference v-if="showShippingPreference&&hasPower('PREFERENCE')" :waybillNo="formData.waybillNo"/>
        <el-button
          v-if="hasPower('SENDPICKCODE')"
          type="primary"
          class="btn-query"
          :disabled="!isDisabledResend||countdown"
          @click="ResendPickupCode"
        >
          <span v-if="!countdown">{{ $lang("重发取件码") }}</span>
          <span v-else>{{countdown}}秒之后重发</span>
        </el-button>
        <el-button
          v-if="$route.name === 'callCenter'"
          type="primary"
          size="small"
          @click="$refs.sendSMSDialog.visible = true"
          >{{ $lang("发送短信") }}</el-button
        >
        <el-button size="small" @click="resetFn">{{ $lang("清空") }}</el-button>
      </template>
      <!-- <LabelInputField
        ref="labelField"
        v-if="!isUpgrade"
        key="problemDescription"
        slot="problemDescription"
        isRequired
        :list="descriptionList"
        :disabled="isUpgrade"
        :showUrgentLabel="formData.showUrgentLabel"
        :urgentOrderFlag="formData.urgentOrderFlag"
        @update:urgent="(val) => formData.urgentOrderFlag = val"
        @innerText="(val) => (formData.problemDescription = val)"
        @labelTextList="(val) => (formData.labelList = val)"
        @innerHTML="(val) => (problemDescriptionInnerHTML = val)"
        @textareaFocus="setTimeStamp"
      /> -->
      <LabelDescription
        key="problemDescription"
        slot="problemDescription"
        isRequired
        :list="descriptionList"
        :disabled="isUpgrade"
        :isNotInsert="formData.isAiStatus"
        :showUrgentLabel="formData.showUrgentLabel"
        :urgentOrderFlag.sync="formData.urgentOrderFlag"
        :labelList.sync="formData.labelList"
        :problemDescription.sync="formData.problemDescription"
        @textareaFocus="setTimeStamp"
      />
      <!-- <template slot="pathList">
        <upload-file
            ref="uploadAll"
            v-model="formData.pathList"
            :limit="8"
            :uploadTips="!isUpgrade"
            :fileTypeList="['jpg','png','jpeg','zip','mp3','mp4']"
            :isView="isUpgrade"
            :key="leftFormSessionId"
          />
      </template> -->
      <template slot="problemDescriptions">
        <span class="suggestBtn" v-loading="dialogOrderSuggestLoading" @click="handleOrderSuggest">{{ $lang("录单小助手") }}<i class="el-icon-circle-plus"></i></span>
      </template>
    </service-form>

    <waybill-dialog ref="waybillDialog" @selectWaybill="selectWaybill"></waybill-dialog>
    <!-- 发送短信 -->
    <send-sms-dialog-new
      ref="sendSMSDialog"
      :type="1"
      :callBackPhone="formData.callBackPhone"
      :waybillNo="formData.waybillNo"
      :firstProblemTypeCode="formData.firstTypeCode"
      :showData="formData"
    />
  </div>
</template>

<script>
import WaybillDialog from '@/components/record/WaybillDialog';
import OrderInfoForm from '@/components/record/OrderInfoForm';
import JmsSoftphone from '@/components/NewSoftphone.vue';
import MiSoftphone from '@/components/MiSoftphone.vue';
import { RULES } from '@/common/utils/validators';
import { RecordSheet } from '@/components/record/pool';
import { debounce } from '@public/utils/common';
import { RESPONSE_CODE } from '@public/http/config';
import mixin from '@mixins/mixin';
import { DICT } from '@/common/utils/dict';
import { PRODADDRESS } from '@/common/config/index';
import * as CONST_TYPE from '@public/utils/const';
import { mapGetters } from 'vuex';
import { isEmptyObj } from '@/common/utils/tool';
// import AbnomalTip from '@/components/record/AbnormalTip';
import validateMsgMixin from '@/common/mixin/validateMsgMixin';
// import DotInformation from './DotInformation.vue';
import WaybillTagContent from '@/views/WaybillTagContent/index.vue';
import ShippingPreference from '@/views/WaybillTagContent/ShippingPreference.vue';

const REMINDER_MODE_MAP = {
  NOT_HANDLE: 1, // 暂不处理
  REMINDER: 2, // 催单
  UPGRADE: 3 // 升级
};

// 运单号正则UAT
const WAYBILL_NO_REGEX_UAT = /^([JU]T)\d{13}$|^\d{13}$/;
// 运单号正则PRO
const WAYBILL_NO_REGEX_PRO = /^(JT)\d{13}$|^\d{13}$/;

// 手机号码正则
const PHONE_REGEX = /(^1[3-9]\d{9}$)|(^[0｜2-9]\d{5,14}$)/;
// 手机号码正则2
const PHONE_REGEX2 = /^(\d)\1{5,14}$/;
// 手机号码正则3
const PHONE_REGEX3 = /(^1[3-9]\d{9}$)|(^[0｜2-9]\d{5,14}$)|(^1[3-9]\d{13}$)/;
// 订单规则正则
const ORDER_RULE_REGEX = /^([0-9]{18,19})$/;

const getOriginForm = () => ({
  waybillNo: '',
  customerPhone: '',
  customerName: '',
  userName: '',
  userCode: '',
  customerCode: '',
  customerSex: 1,
  customerType: '',
  receiverAreaId: '',
  receiverDetailedAddress: '',
  firstType: '',
  firstTypeId: '',
  firstTypeName: '',
  secondTypeId: '',
  secondTypeName: '',
  secondTypeCode: '',
  processingMode: 1, // 关闭 / 转单
  reminderMode: 0, // 不处理 / 催单 / 升级
  groupType: 1,
  centerGroupType: 1,
  // emergencyLevel: 2,
  memberType: 2,
  networkId: '',
  reminderReason: '',
  problemDescription: '',
  callBackName: '',
  callBackPhone: '',
  handlingOpinions: '',
  isProject: '',
  bsType: false, // 接口返回百世物流轨迹状态
  orderId: '',
  soundRecordId: '',
  hqVip: false, // 是否为总部vip
  typeReceiverProvinceName: '',
  typeReceiverProvinceId: '',
  typeReceiverCityName: '',
  typeReceiverCityId: '',
  typeReceiverAreaName: '',
  typeReceiverAreaId: '',
  typeReceiverDetailedAddress: '',
  labelList: [],
  showUrgentLabel: false, // 是否显示加急
  urgentOrderFlag: 2, // 是否加急
  // pathList: [],
  responsibleNetworkCode: '',
  responsibleNetworkId: '',
  responsibleNetworkName: '',
  timestamp: new Date().getTime(),
  showGraySwitch: false, // 是否显示灰化切换
  isAiStatus: false, // 是否是智能回复
  reminderNetworkId: null,
  supportTransferToHeadQuarters: false, // 是否支持转总部
  upgradeNetworkTypeId: '',
  upgradeNetworkId: '',
  agentAreaNetwork: {}
});

export default {
  name: 'LeftForm',
  mixins: [mixin, validateMsgMixin],
  components: {
    WaybillDialog,
    OrderInfoForm,
    JmsSoftphone,
    MiSoftphone,
    WaybillTagContent,
    ShippingPreference
    // AbnomalTip,
    // DotInformation
  },
  props: {
    noPhoneBar: {
      type: Boolean,
      default: false
    },
    // 在线客服
    isService: {
      type: Boolean,
      default: false
    },
    // 页面判断日志操作
    channel: {
      type: String,
      default: '1'
    },
    customerInfo: {
      type: Object,
      default: () => {}
    },
    leftFormSessionId: {
      type: String,
      default: ''
    },
    // 引入工单小结
    isOrderSuggest: Boolean,
    // 右侧基础信息
    baseOrderInfo: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      addressInitData: {},
      customerAddressData: {},
      typeReceiver: {},
      addressReqNetwork: null, // 无单转单,转单类型
      // 催单理由
      reasonOptions: DICT.urgeReason,
      transferOrderOwner: '',
      // 运单字段是否需要展示
      waybillVisible: false,
      // 运单是否已存在
      waybillExist: false,
      loading: false,
      secondTypeLoading: false,
      restartOrder: false, // 重启工单状态
      COM_HTTP: RecordSheet,
      isShowFirst: false,
      defaultGroup: 1,
      formData: getOriginForm(),
      firstTypeList: [],
      secondTypeList: [],
      keywordList: [],
      networkGroup: [],
      // 转单责任网点
      transferNetwork: {},
      // 默认网点
      defaultNetwork: {},
      softPhoneObj: {},
      upgradeNetwork: '',
      types: [],
      timer: null,
      emergencyCict: [
        {
          label: '一般',
          value: 2
        },
        {
          label: '紧急',
          value: 1
        }
      ],
      memberType: 2, // 会员标识，用于重置
      screenWidth: 0,
      allNetwork: {},
      customerNum: '',
      isProblemType: 2, // 是否是问题件,默认否
      questionList: [], // 工单话术
      descriptionList: [], // 问题描述工单话术
      immortalTrailList: [], // 百世物流轨迹
      reminderModeMap: REMINDER_MODE_MAP,
      orderSourceName: '', // 运单号来源
      storageType: true,
      isAll: false,
      waybillType: false, // 运单号校验状态
      onState: false, // 声通电话接听状态
      sensePhone: '', // 存储声通传递电话
      customerAddress: '', // 来电归属
      uuidOne: '',
      prescriptionData: {}, // 时效限制轨迹数据
      orderTip: '', // 订单提示
      cancelExplain: '', // 订单取消原因
      customerTagList: [],
      storageBasicInfo: {}, // 存储基础信息
      hqVip: false, // 是否为总部vip
      isOpinionChange: false, // 是否更改处理意见
      isChangeOpinions: false, // 是否更改了问题描述
      isConsolidation: false,
      // customerExcList: {}, // 网点异常管理--异常信息--客户编号异常
      isEmptyObj: isEmptyObj,
      problemDescriptionStr: '', // 校验文字
      pickUpNetworkName: '', // 面单发放网点
      problemDescriptionInnerHTML: '', // 问题描述
      channelName: '外包端-录单',
      routeName: '',
      isCainiaoStation: false, // 是否菜鸟
      isWorkOrderEnable: false,
      dialogOrderSuggest: false,
      dialogOrderSuggestLoading: false,
      suggestData: {
        firstLevel: '',
        secondLevel: '',
        description: ''
      },
      countdownPhone: 0,
      countdownIntervalPhone: null,
      suggestRecordId: '',
      countdown: 0,
      countdownInterval: null,
      hasManualOperation: false, // 标记用户是否手动操作过输入框,默认非手输入的,
      isAiSetType: false, // 是否通过录单小助手设置的类型
      switchDamaged: true // 开关：录单二级是破损置灰 这个逻辑的开关，关闭之后 这个逻辑不生效
    };
  },
  created() {
    console.log('created')
    this.routeName = this.$route.name
    // 单号输入防抖
    this.debounceFn = debounce(this.checkWaybillExist, 500);
    this.debounceOrder = debounce(this.checkOrderExist, 500);
    // 手机号码获取运单号执行方法 防抖
    this.queryOrder = debounce(this.queryOrderPhone, 500);
    this.queryDataAddress = debounce(this.getDataAddress, 500); // 根据地址获取运单信息
    this.setScreenWidth();
    window.addEventListener('resize', this.setScreenWidth);

    // 父级做事件巴士
    this.$parent.$on('getIsAll', (isAll) => {
      this.isAll = isAll;
      this.getInfoByInput();
      this.getTraceDataList();
      this.getPrescription();
    });
    // this.$bus.$on('leftFormHandlingOpinions', handlingOpinions => {
    //   this.formData.handlingOpinions = handlingOpinions
    // })
    this.isService && this.requestIsHqVip();
  },
  destroyed() {
    window.removeEventListener('resize', this.setScreenWidth);
    this.$parent.$off('getIsAll');
    this.clearCountdownPhone();
    this.clearCountdown();
  },
  watch: {
    'imStorage.imUserList': {
      deep: true,
      immediate: true,
      handler(userList) {
        // userList = ''
        if (userList && userList.length) {
          const obj = userList.find((item) => item.isSelected) || {};
          console.log(JSON.stringify(obj));
          // im传递字段customerLevel：1 普通用户，2 vip用户
          setTimeout(() => {
            this.formData.memberType = this.memberType =
              `${obj.customerLevel}` === '2' ? 1 : 2;
          });
        }
      }
    },
    // 处理模式禁用时不能选转单
    modeDisabled(newVal) {
      if (newVal) {
        this.formData.processingMode = 1;
      }
    },
    keywordList(list = []) {
      this.waybillExist = !!list.length;
      this.$emit('trailList', list);
      this.getPrescription();
    },
    '$route.name': {
      handler(name) {
        // 切换回来页面 并且有缓存数据，调回传方法
        if (name === 'callCenter' && this.callbackWaybill) {
          this.changeWaybill(this.callbackWaybill);
          this.callbackWaybill = '';
        }
        // 在线客服 返回当前页再请求一级列表
        if (
          ['imOnline', 'callCenter', 'imService', 'imServiceNew'].includes(name) &&
          this.firstTypeList.length === 0
        ) {
          this.getFirstType();
        }
      },
      immediate: true
    },
    customerInfo: {
      handler() {
        const { sessionId, customerPhone } = this.customerInfo;
        this.hasManualOperation = true; // 切换通话的时候 默认号码是手收入，当获取到号码时，将标记改为非手输入
        if (customerPhone) {
          RecordSheet.getPhoneDetail(sessionId).then(({ data = '' }) => {
            this.formData.customerPhone = data;
            this.hasManualOperation = false;
            console.log('111111', 'customerInfo', this.formData.customerPhone)
          });
        }
      },
      deep: true
    },
    'formData.customerPhone'(value) {
      value = (value || '').replace(/\s/g, '')
      if (!value || PHONE_REGEX.test(value)) {
        this.$emit('customerPhone', value)
        // this.routeName === 'callCenter' && this.$bus.$emit('setCustomerPhone', value)
        // this.routeName === 'imService' && this.$bus.$emit('setCustomerPhoneIM', value)
      }
      // this.formData.customerPhone = value
    }
  },
  methods: {
    // 反查寄件人号码带入来电号码
    async intoCustomerPhone() {
      if (this.countdownPhone) {
        this.$message.error('请勿频繁点击')
        return
      }
      const params = {
        waybillId: this.formData.waybillNo,
        queryReason: 'KFLD',
        orderSourceCode: this.storageBasicInfo.orderSourceCode,
        queryType: 1
      }
      this.setTimerPhone()
      const { code, data } = await RecordSheet.reqOrderInfoPlaintext(params)
      const { senderMobilePhone, senderTelphone } = data || {}
      const valueStr = senderMobilePhone || senderTelphone
      if (code === RESPONSE_CODE.SUCCESS && valueStr && !valueStr.includes('*')) {
        this.formData.customerPhone = senderMobilePhone || senderTelphone
        this.hasManualOperation = false;
        console.log('111111', 'intoCustomerPhone', this.formData.customerPhone)
        this.formData.callBackPhone = this.formData.customerPhone || ''
        this.$refs.form.validateField('customerPhone');
        this.$refs.form.validateField('callBackPhone');
      } else {
        this.$message.error('自动带入失败，请主动和客户确认来电号码')
      }
    },
    setTimerPhone() {
      this.clearCountdownPhone()
      this.countdownPhone = 3
      this.countdownIntervalPhone = setInterval(() => {
        if (this.countdownPhone === 0) {
          return
        }
        this.countdownPhone -= 1
      }, 1000)
    },
    clearCountdownPhone() {
      if (this.countdownInterval) {
        clearInterval(this.countdownInterval);
        this.countdownInterval = null;
      }
    },
    changeProcessingMode() {
      if (this.formData.processingMode === 2) {
        this.judgmentVip(); // 触发组别change事件
      }
    },
    handlePhoneFocus() {
      // 用户点击输入框，标记为手动操作
      this.hasManualOperation = true;
      console.log('111111', 'handlePhoneFocus--手动获取焦点', this.formData.customerPhone)
      this.setTimeStamp();
    },
    clearCustomerPhone() {
      if (!this.formData.customerPhone) {
        this.customerAddress = '';
        this.customerTagList = [];
      }
    },
    /**
     *  重发取件码
     * waybillNo：true --运单号存在
     * waybillExist：true --运单号正确
     * keywordList：length --数据列表不为空
     */
    async ResendPickupCode() {
      console.log(
        this.formData.waybillNo,
        '==' + this.waybillExist,
        this.keywordList.length
      );
      try {
        const { waybillNo, customerPhone } = this.formData
        if (
          waybillNo &&
          this.waybillExist &&
          this.keywordList.length !== 0
        ) {
          const params = { addresseePhone: this.isCainiaoStation ? customerPhone : undefined, billCode: waybillNo }
          this.setTimer()
          const { code, msg } = await RecordSheet.ResendPickupCode(params)
          if (code === RESPONSE_CODE.SUCCESS) {
            this.$message.success(this.$lang('重发取件码请求已提交'))
          } else {
            this.$message.error(msg)
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    setTimer() {
      this.clearCountdown()
      this.countdown = 3
      this.countdownInterval = setInterval(() => {
        if (this.countdown === 0) {
          return
        }
        this.countdown -= 1
      }, 1000)
    },
    clearCountdown() {
      if (this.countdownInterval) {
        clearInterval(this.countdownInterval);
        this.countdownInterval = null;
      }
    },
    // 选中常用话术
    selectQuestion(id) {
      for (const item of this.questionList) {
        item.isChecked = item.id === id;
        if (item.id === id) this.formData.handlingOpinions = item.fastWord;
      }
    },
    // 获取工单话术列表
    async getfastWordsList() {
      // typeId: this.formData.secondTypeId
      this.questionList = []
      this.descriptionList = []
      if (!this.formData.secondTypeId || this.isUpgrade) return
      // if (!this.isOpinionChange) {
      //   this.formData.handlingOpinions = ''
      //   this.formData.problemDescription = ''
      // }
      const { code, data, msg } = await RecordSheet.getfastWordsList({ current: 1, size: 9999, secondTypeId: this.formData.secondTypeId })
      if (code === RESPONSE_CODE.SUCCESS) {
        this.questionList = data.records?.filter(item => item.labelPosition === 1) || []
        this.descriptionList = data.records?.filter(item => item.labelPosition === 2) || []
      } else {
        this.$message.error(msg)
      }
    },
    // 回填信息
    getBillDetal(userCode, waybillCode, mobilePhone, receiverName, type, onlineChannelSourceCode) {
      console.log('111111', 'getBillDetal', this.formData.customerPhone)
      this.storageType = true;
      // 是否是会员
      if (!waybillCode && !mobilePhone && !receiverName) return;
      let code = waybillCode || this.formData.waybillNo;
      let phone = mobilePhone || this.formData.customerPhone;
      let name = receiverName || this.formData.customerName;
      if (type) {
        code = waybillCode;
        phone = mobilePhone;
        name = receiverName;
      }
      debounce(this.checkWaybillExist(code), 500);
      this.formData.customerCode = userCode;
      // 渠道
      this.formData.onlineChannelSourceCode = onlineChannelSourceCode
      // 运单号
      // this.formData.waybillNo = code
      // 来电号码
      this.formData.customerPhone = phone;
      this.hasManualOperation = false;
      console.log('111111', 'getBillDetal--回填信息', this.formData.customerPhone)

      // 来访对象
      this.formData.customerName = name;
      // 回电号码
      this.changeCustomerPhone(phone);
      // 回电对象
      if (name) {
        const sex = this.formData.customerSex === 1 ? '先生' : '女士';
        this.formData.callBackName = name + sex;
        this.$refs.form.validateField('callBackName');
      }
    },
    // 性别更改需要更改回电对象
    changeGender(val) {
      const { customerName, customerSex } = this.formData;
      const sex = customerSex === 1 ? '先生' : '女士';
      if (customerName) {
        this.formData.callBackName = customerName + sex;
      }
    },
    // 电话条回传运单号
    changeWaybill(num) {
      this.storageType = true;
      if (num) {
        if (this.$route.name === 'callCenter') {
          this.formData.waybillNo = num;
          this.checkWaybillExist(num);
        } else {
          // 不在当前页面缓存数据
          this.callbackWaybill = num;
        }
      }
    },
    changePhone(num = '') {
      this.formData.customerPhone = num;
      this.hasManualOperation = false;
      console.log('111111', 'changePhone', this.formData.customerPhone)
      this.formData.callBackPhone = num;
      if (num) {
        this.onState = true;
        this.sensePhone = num;
        // 重置国际件查询状态
        this.storageType = true;
        this.getcustomerNum(num);
        this.phoneExp(num) && this.setTheLog('1');
      }
    },
    // 电话挂断触发
    talkEnd() {
      this.onState = false;
      this.sensePhone = '';
    },
    getcustomerNum(num) {
      RecordSheet.getInfoByMobile({
        mobile: num,
        waybillNo: this.formData.waybillNo
      }).then((res) => {
        const { code, msg, data } = res;
        if (code === RESPONSE_CODE.SUCCESS) {
          this.customerNum = data.callTimes;
          // 运单号(不传会根据手机号反查最新运单号，传了则返回原值)
          this.formData.waybillNo = data.waybillNo;
          this.checkWaybillExist(data.waybillNo);
          return;
        }
        this.$message.error(msg);
      });
    },
    changeInputPhone(value) {
      // 当回电号码未改变过时要把值写入回电号码
      console.log('changeInputPhone>>>>', value)
      if (value) {
        value = value.replace(/\D/g, '')
        this.formData.customerPhone = value;
        this.formData.callBackPhone = value;
        this.$refs.form.validateField('customerPhone');
        this.$refs.form.validateField('callBackPhone');
        this.customerNum = '';
        this.phoneExp(value) && this.setTheLog('2');
        // 标记为用户手动操作
        this.hasManualOperation = true;
        console.log('111111', 'changeInputPhone', this.formData.customerPhone)
      }
    },
    changeCustomerPhone(value) {
      // 当回电号码未改变过时要把值写入回电号码
      value = (value || '').replace(/\s/g, '');
      if (value) {
        this.formData.customerPhone = value;
        this.hasManualOperation = false;
        console.log('111111', 'changeCustomerPhone', this.formData.customerPhone)
        this.formData.callBackPhone = value;
        this.$refs.form.validateField('customerPhone');
        this.$refs.form.validateField('callBackPhone');
      }
    },
    // 获取一级类型
    getFirstType() {
      this.COM_HTTP.getFirstInputType().then(({ code, data, msg }) => {
        if (code === RESPONSE_CODE.SUCCESS) {
          this.firstTypeList = data
            .sort(
              (o, n) =>
                new Date(o.createTime).getTime() - new Date(n.createTime).getTime()
            )
            ?.filter((o) => o.code !== '11'); // 隐藏极速理赔
          // 【总部客服组|888889】 【总部客服组02|888887】【总部客服组03|888885】
          const filterList = ['888889', '888887', '888885'];
          const { networkCode } = this.user;
          this.firstTypeList = this.firstTypeList?.filter((o) => {
            if ((o.code === '5' && this.isNet) || (o.code === '5' && this.isCenter)) {
              if (filterList.includes(networkCode)) return o;
            } else {
              return o;
            }
          });
          const select =
            this.firstTypeList.find((o) => o.name === '催查件') ||
            data?.find((o) => o.code === '20'); // 催查件
          this.formData.firstType = select.id; // 默认勾选
          this.changeFirstType(select.id);
        }
      });
    },
    handleChangeGroupType() {
      this.formData.networkId = '';
      if (
        !this.networkOptions.find((o) => o.id === this.formData.networkId) &&
        this.networkOptions[0]
      ) {
        this.formData.networkId = this.networkOptions[0].id;
      }
      this.changeNetwork(this.formData.networkId);
    },
    handleChangeGroupTypeNew() {
      if (this.formData.reminderMode === 3) {
        const networkIds = this.networkGroup.find(item => item.groupType === this.formData.reminderModeType)?.networks || []
        const { agentAreaNetwork } = this.formData
        this.formData.upgradeNetworkId = networkIds?.[0]?.id || ''
        if (this.formData.reminderModeType === 2) {
          this.formData.upgradeNetworkId = agentAreaNetwork?.id || networkIds?.[0]?.id || ''
        }
      }
    },
    // 获取物流轨迹网点
    async getNetworkList() {
      this.allNetwork = {};
      this.changeNetwork();
      const netList = this.keywordList
        ?.filter((item) => {
          return (
            item.scanNetworkCode && item.isEntrepot !== 1 && item.isRetrogression !== 1
          );
        })
        .map((o) => o.scanNetworkCode);
      netList.push('0'); // 确保不为空

      const firstPOD = this.keywordList[0] || {};
      if (
        firstPOD.nextNetworkCode &&
        !['到件扫描', '集货到件', '中心到件'].includes(firstPOD.scanTypeName)
      ) {
        firstPOD.nextSiteIsEntrepot !== 1 && netList.unshift(firstPOD.nextNetworkCode);
      }
    },
    // 回填运单信息
    setWaybill(item) {
      this.waybillExist = !!this.keywordList.length;
      console.log(item);
      if (!item || !item.waybillNo) return;
      this.waybillExist = true;
      const {
        receiverDetailedAddress,
        receiverProvinceName,
        receiverProvinceId,
        receiverCityId,
        receiverCityName,
        receiverAreaId,
        receiverAreaName,
        waybillNo
      } = item;
      if (!this.isPlaceOrder) {
        this.formData.receiverDetailedAddress = receiverDetailedAddress;
        if (!receiverProvinceId) {
          this.formData.receiverAreaId = '';
          this.addressInitData = {};
        } else if (!receiverCityId) {
          this.setAddressData(receiverProvinceId, receiverProvinceName, null, null, null, null);
        } else if (!receiverAreaId) {
          this.setAddressData(receiverProvinceId, receiverProvinceName, receiverCityId, receiverCityName, null, null);
        } else {
          this.formData.receiverAreaId = receiverAreaId;
          this.setAddressData(receiverProvinceId, receiverProvinceName, receiverCityId, receiverCityName, receiverAreaId, receiverAreaName);
        }
      }
      this.changeCustomerPhone(this.formData.customerPhone);
      Object.assign(this.formData, { waybillNo });
      setTimeout(() => {
        this.$refs.form.validateField('receiverAreaId');
      });
    },
    // 地址赋值
    setAddressData(provinceId, provinceName, cityId, cityName, areaId, areaName) {
      this.addressInitData = {
        provinceId: provinceId,
        provinceName: provinceName,
        cityId: cityId,
        cityName: cityName,
        areaId: areaId,
        areaName: areaName
      };
    },
    changeAddress(data) {
      console.log(this.formData, 'this.formData')
      Object.assign(this.formData, {
        receiverAreaId: data.areaId,
        receiverAreaName: data.areaName,
        receiverCityId: data.cityId,
        receiverCityName: data.cityName,
        receiverProvinceId: data.provinceId,
        receiverProvinceName: data.provinceName
      });
      if (this.duoduonixiang) {
        Object.assign(this.formData, {
          typeReceiverProvinceName: data.provinceName,
          typeReceiverProvinceId: data.provinceId,
          typeReceiverCityName: data.cityName,
          typeReceiverCityId: data.cityId,
          typeReceiverAreaName: data.areaName,
          typeReceiverAreaId: data.areaId
        });
        this.typeReceiver = data
      }

      this.$refs.form.validateField('receiverAreaId');
    },
    validatorWaybill(rule, value, callback) {
      this.waybillType = false;
      if (!value) return;
      if (!WAYBILL_NO_REGEX_UAT.test(value)) {
        callback(new Error(this.$lang('请输入正确的运单号')));
        return;
      }
      // 不存在物流轨迹时判断有无面单发放网点
      if (
        value &&
        !this.waybillExist &&
        this.keywordList.length === 0 &&
        this.immortalTrailList.length === 0 &&
        !this.pickUpNetworkName
      ) {
        callback(new Error(this.$lang('不存在该面单')));
      }
      this.waybillType = true;
      callback();
    },
    // 物流跟踪
    async getTraceDataList() {
      if (!this.formData.waybillNo) {
        return;
      }
      const { code, data, msg } = await RecordSheet.traceDataList(
        this.formData.waybillNo,
        this.isAll
      );
      if (code !== RESPONSE_CODE.SUCCESS_COPY) {
        this.$message.warning(msg);
      }
      this.keywordList = [];
      if (data && data[0] && data[0].details) {
        this.keywordList = data[0].details;
      }
      this.$refs['form'].validateField('waybillNo');
      // 根据物流轨迹获取对应的网点
      this.getNetworkList();
    },
    // 查询回填
    selectWaybill({ waybillNo }) {
      waybillNo && this.checkWaybillExist(waybillNo);
    },
    // 请求百世单号轨迹信息
    async getImmortalTrail() {
      const { waybillNo } = this.formData;
      if (!waybillNo || waybillNo.substr(0, 2) !== '55') {
        return;
      }
      // 传递兄弟组件
      this.$bus.$emit('getBsTrack', { waybillNo, isBs: true });
      try {
        const { data, msg, code } = await RecordSheet.getQueryBs({
          billCodes: [waybillNo]
        });
        if (code === RESPONSE_CODE.SUCCESS) {
          this.immortalTrailList = data || [];
        } else {
          this.$message.error(msg);
        }
        this.$refs['form'].validateField('waybillNo');
      } catch (e) {
        console.log(e);
      }
    },
    // 检查运单是否存在并且获取运单详情及物流轨迹
    async checkWaybillExist(waybillNo = '') {
      this.networkGroup = [];
      this.keywordList = [];
      this.immortalTrailList = [];
      this.addressInitData = {};
      this.formData.receiverDetailedAddress = '';
      // this.formData.pathList = []
      this.problemDescriptionInnerHTML = ''
      if (waybillNo) {
        waybillNo = waybillNo.replace(/\s/g, '');
      } else {
        // 针对55录单
        this.formData.centerGroupType = 1;
        this.defaultGroup = 1;
        this.formData.processingMode = 1;
        this.formData.reminderMode = 0;
      }
      // 运单号开头是否是55
      if (waybillNo && this.storageType) {
        this.storageType = false;
        if (waybillNo.length < 2) return this.changeWaybillNo('', false);
        const str = waybillNo.substring(0, 2).toUpperCase();
        if (location.hostname === PRODADDRESS) {
          if (str === 'JT') {
            waybillNo = str + waybillNo.substring(2, waybillNo.length);
          } else {
            waybillNo = 'JT' + waybillNo;
          }
        } else {
          if (str === 'UT' || str === 'JT') {
            waybillNo = str + waybillNo.substring(2, waybillNo.length);
          } else {
            waybillNo = 'UT' + waybillNo;
          }
        }
      }
      // 发是否符合调接口的规则
      let succcess = false;
      succcess =
        location.hostname === PRODADDRESS
          ? WAYBILL_NO_REGEX_PRO.test(waybillNo)
          : WAYBILL_NO_REGEX_UAT.test(waybillNo);
      this.formData.waybillNo = waybillNo;
      this.$refs.form.resetFields();
      if (waybillNo && succcess) {
        // await this.$refs.abnomalTip.getNetWaybill(waybillNo);
        await this.getConsolidation(waybillNo);
        // 异常客服编号提示
        // await this.getCustomerExc(waybillNo);
        await this.getTraceDataList();
        // 获取bs物流轨迹
        await this.getImmortalTrail();
        this.getWaybillDetail();
        this.hasPower('SENDPICKCODE') && this.checkCainiaoStation()// 判断快递是否在菜鸟驿站
      } else {
        this.setWaybill();
        this.keywordList = [];
        this.formData.reminderMode = 0;
        this.formData.processingMode = 1;
        this.changeNetwork();
      }
      this.getInfoByInput();
      this.changeWaybillNo(waybillNo, succcess);
    },
    /**
     * 客户地址
     */
    typeReceiverAddressHandler(data) {
      console.log(data, 'data>>>>>>>>')
      const { areaName = '', cityName = '', provinceName = '', areaId = '', cityId = '', provinceId = '' } = data
      this.formData = {
        ...this.formData,
        typeReceiverProvinceName: provinceName,
        typeReceiverProvinceId: provinceId,
        typeReceiverCityName: cityName,
        typeReceiverCityId: cityId,
        typeReceiverAreaName: areaName,
        typeReceiverAreaId: areaId
      }
      if (this.duoduonixiang) {
        Object.assign(this.formData, {
          receiverProvinceName: data.provinceName,
          receiverProvinceId: data.provinceId,
          receiverCityName: data.cityName,
          receiverCityId: data.cityId,
          receiverAreaName: data.areaName,
          receiverAreaId: data.areaId
        });
        this.addressInitData = data
      }
      this.queryDataAddress('typeReceiver')
    },
    // 设置来电归属地
    async getCustomerAddress(phone) {
      try {
        const { data } = await this.COM_HTTP.reqCustomerAddress(phone);
        data &&
          (this.customerAddress = data.province && `${data.province}   ${data.city}`);
      } catch (error) {
        console.log(error);
      }
    },
    // 获取标签
    async getQueryByPhone(phone) {
      try {
        const { data } = await this.COM_HTTP.queryByPhone(phone);
        if (data) {
          this.customerTagList = data;
        }
      } catch (error) {
        console.log(error);
      }
    },
    /**
     * 请求百世基础信息回填
     */
    async getBsWaybillDetail(waybill) {
      try {
        const { data, code, msg } = await RecordSheet.queryBillBs({
          billCodes: [waybill]
        });
        if (code === RESPONSE_CODE.SUCCESS) {
          this.setWaybill(data && data[0] ? data[0] : {});
          this.formData.userCode = data.customerCode || '';
          this.formData.userName = data.customerName || '';
        } else {
          this.$message.error(msg);
        }
      } catch (error) {
        console.log(error);
      }
    },
    changeWaybillNo(waybillNo, succcess) {
      this.formData.waybillNo = waybillNo;
      this.$refs.form.validateField('waybillNo');
      if (!succcess) waybillNo = '';
      this.storageBasicInfo = {};
      this.$emit('waybillNo', waybillNo);
    },
    changeFirstType(firstId, isEmpty = true, secondLevel, description) {
      this.setTimeStamp()
      this.formData.networkId = '';
      // 需设置code name id
      this.formData.firstType = firstId
      this.formData.firstTypeId = firstId;
      // 手动选择类型时重置AI设置类型标记
      if (!secondLevel) {
        this.isAiSetType = false;
      }
      const { code, name } = this.firstTypeList.find((item) => item.id === firstId) || {};
      this.formData = {
        ...this.formData,
        ...(isEmpty && {
          secondTypeId: '',
          secondTypeCode: '',
          secondTypeName: ''
        }),
        firstTypeCode: code,
        firstTypeName: name
      };
      this.waybillVisible = false;
      this.transferOrderOwner = '';
      this.secondTypeLoading = true;
      this.secondTypeList = [];
      this.COM_HTTP.getSecondType({
        id: firstId,
        waybillNo: this.formData.waybillNo,
        channelName: this.channelName
      }).then(({ code, data, msg }) => {
        this.secondTypeLoading = false;
        if (code === RESPONSE_CODE.SUCCESS) {
          this.secondTypeList = data.secondListVOList || [];
          // 时效限制轨迹数据
          const {
            currentDuration,
            estimateDuration,
            transportationStatus,
            isPrescription
          } = data || {};
          this.prescriptionData = {
            currentDuration,
            estimateDuration,
            transportationStatus,
            isPrescription
          };
          this.$emit('prescriptionData', this.prescriptionData);
          // 集运仓件-禁用签收未收到
          this.secondTypeList = this.secondTypeList.map((o) => {
            o.code === '2104' &&
              this.formData.waybillNo &&
              this.isConsolidation &&
              (o.isDisabled = true);
            return o;
          });
          let id = ''
          if (secondLevel) {
            id = this.secondTypeList.filter(item => item.name === secondLevel)[0]?.id
            if (id === '787520834947277628') { // 如果二级类型是 破损
              RecordSheet.getSwitchDamaged().then(({ code, data, msg }) => {
                if (code === RESPONSE_CODE.SUCCESS) {
                  this.switchDamaged = data;
                }
              }).catch(() => {
                this.switchDamaged = true;
              })
            }
          }
          isEmpty && this.changeSecondType(id, true, description);
        }
      });
    },
    // 二级类型改变设置
    // 选择二级类型 (如果为下单，则需展示下单表单)
    // isHandSet 标识是不是手动选择二级标签
    async changeSecondType(id, type, description, isHandSet = false) {
      this.setTimeStamp()
      this.handleInfo({})
      if (isHandSet) {
        this.isAiSetType = false;
      }
      this.formData.networkId = '';
      this.formData.orderId = '';
      this.orderTip = '';
      this.problemDescriptionInnerHTML = ''
      let item = {};
      // 无单转单清空
      this.addressReqNetwork = null;
      this.customerAddressData = {};
      this.formData.details = '';
      // 清空责任方
      Object.assign(this.formData, {
        responsibleNetworkCode: '',
        responsibleNetworkId: '',
        responsibleNetworkName: ''
      })
      if (id) {
        item = this.secondTypeList.find((item) => item.id === id) || {};
        console.log(item, 'item')
        const { code, name, reminderCount, treatmentLimitation, id: secondTypeId, noWaybillTransfer, noWaybillTransferType } = item;
        this.formData = {
          ...this.formData,
          secondTypeId: secondTypeId,
          secondTypeCode: code,
          secondTypeName: name,
          secondTypeReminderCount: reminderCount,
          secondTypeTreatmentLimitation: treatmentLimitation,
          noWaybillTransfer, noWaybillTransferType
        };
        this.transferOrderOwner = item.transferOrderOwner;
        this.getfastWordsList();
        if (['2012', '2001'].includes(code)) {
          this.addressInitData = {};
          this.formData.receiverDetailedAddress = '';
        }
        if (name === '下单') {
          this.waybillVisible = true;
          this.keywordList = [];
          this.changeWaybillNo('');
          this.defaultGroup = 1;
          this.addressInitData = {};
          this.formData = {
            ...this.formData,
            receiverDetailedAddress: '',
            processingMode: 1,
            reminderMode: 0,
            centerGroupType: 1
          };
          this.restartOrder = false;
        } else {
          this.waybillVisible = false;
        }
        this.noSingleTransferOrder({ noWaybillTransferType })
      }
      const { standardReply = '', problemRemark = '' } = item;
      if (!this.isOpinionChange) {
        this.formData.handlingOpinions = standardReply;
      }
      if (
        ![REMINDER_MODE_MAP.REMINDER, REMINDER_MODE_MAP.UPGRADE].includes(
          this.formData.reminderMode
        ) &&
        !this.isChangeOpinions
      ) {
        let problemRemarkNew = !this.formData.isAiStatus ? problemRemark : this.formData.problemDescription
        if (description) {
          problemRemarkNew = description
        }
        this.formData.problemDescription = problemRemarkNew;
        this.problemDescriptionInnerHTML = problemRemarkNew || '';
        this.formData.labelList = []
        this.$refs.labelField?.write(this.formData.problemDescription || '')
      }
      console.log(this.formData);
      this.typeReceiverAddressHandler({})
      this.typeReceiver = {}
      this.formData.typeReceiverDetailedAddress = ''
      // 根据手机号码获取订单信息
      this.queryOrder();
      this.getInfoByInput(type);
    },
    // 无单转单（新）
    noSingleTransferOrder(params) {
      if (this.ifTransferOrder) {
        const { noWaybillTransferType } = params || {}
        this.waybillVisible = false;
        this.orderSourceName = '';
        this.storageType = true;
        this.changeWaybillNo('');
        // noWaybillTransferType无单转单组别为总部组时：不展示客户地址 直接获取：默认给总部组
        noWaybillTransferType === 1 && this.getDataAddress('', true)
      }
    },
    customerAddressHandler(data) {
      const { areaName = '', cityName = '', provinceName = '' } = data;
      this.formData.addressName = provinceName + cityName + areaName;
      this.formData.address = data?.cityId;
      this.formData.details = '';
      this.customerAddressData.details = '';
      this.addressReqNetwork = null;
      this.queryDataAddress();
    },
    /**
     * 根据地址获取运单信息
     */
    async getDataAddress(type, isHqGroup) {
      const address = type === 'typeReceiver' ? this.typeReceiver : this.customerAddressData
      const { provinceId, cityId, areaId, details } = address
      if (!isHqGroup && (!provinceId || !cityId || !areaId || !details)) return
      const { secondTypeCode } = this.formData
      const params = isHqGroup ? { secondTypeCode } : { ...address, secondTypeCode }
      const { data } = await RecordSheet.getInfoByAddress(params)
      this.handleInfo(data)
    },
    /**
     * 无单转单处理信息
     */
    handleInfo(data) {
      this.addressReqNetwork = data || null;
      this.isProblemType = data?.isProblemType;
      if (data?.workOrderDetail) {
        const { customerPhone, callBackPhone } = data.workOrderDetail;
        this.formData = {
          ...this.formData,
          ...data.workOrderDetail,
          isProject: data.isProject,
          callBackPhone: callBackPhone || customerPhone
        };
        if (customerPhone) {
          this.hasManualOperation = false // 非手动输入电话号码
        }
        customerPhone && this.getCustomerAddress(customerPhone);
      }
      if (this.formData.waybillNo && this.keywordList.length !== 0 && this.isService) {
        this.getCheckStatus();
      }
      // 默认网点 defaultNetwork
      const {
        transferNetworkType,
        restartOrder,
        transferNetwork,
        defaultGroup = 1,
        defaultNetwork,
        networkGroup,
        agentAreaNetwork
      } = data;
      const dn = (this.defaultNetwork = defaultNetwork || {});
      // 默认组别 1:关闭 2:网点组 3:代理组 4:总部工单组 5:总部理赔组 6:暂不处理 7:催单 8:升级
      const dg = (this.defaultGroup = defaultGroup);
      this.networkGroup = networkGroup || [];
      // 重启工单状态
      this.restartOrder = restartOrder;
      // 默认转责任单网点
      this.transferNetwork = transferNetwork || '';
      // 重置状态
      this.formData = {
        ...this.formData,
        centerGroupType: 1,
        transferNetworkType: transferNetworkType,
        processingMode: 1,
        reminderMode: 0,
        groupType: 1,
        networkId: '', // 代理区信息(默认组别为升级时才有值)
        agentAreaNetwork: {}
      };
      const da = agentAreaNetwork || {};
      if (dg === 1) {
        this.formData.processingMode = 1;
      } else if ([2, 3, 4, 5].includes(dg)) {
        this.formData.processingMode = 2;
        if ([4, 5].includes(dg)) {
          this.formData.groupType = 3;
          this.formData.centerGroupType = dg - 3;
        } else {
          this.formData.groupType = dg - 1;
        }
        this.changeNetwork(dn.id, true);
      } else if (dg === 7) {
        this.formData.reminderMode = REMINDER_MODE_MAP.NOT_HANDLE;
      } else if (dg === 8) {
        this.formData.groupType = 2;
        this.formData.reminderMode = REMINDER_MODE_MAP.NOT_HANDLE;
        this.formData.networkId = da.id;
        this.formData.agentAreaNetwork = da;
      }
    },
    // 后台录单基础数据
    getInfoByInput(type) {
      this.formData.showUrgentLabel = false
      this.formData.urgentOrderFlag = 2
      this.$refs.labelField?.changeUrgent()
      const { waybillNo, firstTypeId, secondTypeId, orderId } = this.formData;
      if ((!(waybillNo || orderId) || !firstTypeId) && !this.isVisit) {
        return;
      }
      const historyType = this.isAll ? 2 : 1;
      let reqPool = 'getInfoByInput';
      const params = {
        firstTypeId,
        secondTypeId,
        historyType
      };
      // 是否是订单查询 置空运单号
      if (this.isRushTake && orderId && !waybillNo) {
        this.formData.waybillNo = '';
        this.orderSourceName = '';
        this.$emit('waybillNo', this.formData.waybillNo);
        this.$bus.$emit('getOrderId', this.formData.orderId);
        reqPool = 'getInfoByOrderId';
        params.orderId = orderId;
        this.addressInitData = {};
        this.formData.receiverDetailedAddress = '';
      } else {
        params.waybillNo = waybillNo;
        Object.assign(params, { waybillNo, historyType });
      }
      this.formData.isProject = null;
      RecordSheet[reqPool](params).then(({ code, data }) => {
        if (code === RESPONSE_CODE.SUCCESS) {
          this.isProblemType = data.isProblemType;
          if (data && data.workOrderDetail) {
            if (type) {
              delete data.workOrderDetail.secondTypeId;
              delete data.workOrderDetail.secondTypeCode;
              delete data.workOrderDetail.secondTypeName;
              delete data.workOrderDetail.firstTypeId;
              delete data.workOrderDetail.firstTypeCode;
            }
            this.formData = {
              ...this.formData,
              ...data.workOrderDetail,
              isProject: data.isProject,
              firstTypeId: data.workOrderDetail.firstTypeId || firstTypeId,
              firstType: data.workOrderDetail.firstTypeId || firstTypeId,
              reminderNetworkId: data?.reminderNetworkId,
              agentAreaNetwork: {}
              // pathList: data.workOrderDetail.pathList?.map(path => ({
              //   downloadUrl: path
              // }))
            };
            if (data.workOrderDetailcustomerPhone) {
              this.hasManualOperation = false // 非手动输入电话号码
            }
            this.setCustomerPhone();
            this.setWaybill(data.workOrderDetail);
          } else {
            this.formData.isProject = null;
          }
          !type && this.changeFirstType(this.formData.firstTypeId, false);
          if (
            this.formData.waybillNo &&
            (this.keywordList.length !== 0 || this.immortalTrailList.length !== 0) &&
            this.isService
          ) {
            // 去请求存储记录
            this.getCheckStatus();
          }

          // 重置总部组状态 兼容bs
          this.formData.centerGroupType = 1;
          this.formData.transferNetworkType = data.transferNetworkType;
          // 接口返回百世状态
          this.formData.bsType = data.isBs;
          this.networkGroup = data.networkGroup;
          // 默认转责任单网点
          this.transferNetwork = data.transferNetwork;
          // 默认组别 1:关闭 2:网点组 3:代理组 4:总部工单组 5:总部理赔组 6:暂不处理 7:催单 8:升级
          const dg = data.defaultGroup;
          // 重启工单状态
          this.restartOrder = data.restartOrder;
          this.defaultGroup = dg;
          this.formData.processingMode = 0;
          this.formData.reminderMode = 0;
          // 默认网点 defaultNetwork
          this.defaultNetwork = data.defaultNetwork || {};
          const dn = data.defaultNetwork || {};
          // 代理区信息(默认组别为升级时才有值)
          const da = data.agentAreaNetwork || {};
          this.formData.networkId = '';
          // 加急工单
          this.formData.showUrgentLabel = data.showUrgentLabel || false
          const isSupportTransferToHeadQuarters = data?.supportTransferToHeadQuarters || false
          this.formData.supportTransferToHeadQuarters = isSupportTransferToHeadQuarters
          this.formData.upgradeNetworkTypeId = data?.workOrderDetail?.acceptNetworkTypeId
          this.formData.showGraySwitch = data?.graySwitch || false
          if (isSupportTransferToHeadQuarters) {
            this.formData.groupType = 3
            this.formData.processingMode = 2
            this.formData.networkId = da.id
          } else {
            if (dg === 1) {
              this.formData.processingMode = 1;
            } else if ([2, 3, 4, 5].includes(dg)) {
              this.formData.processingMode = 2;
              if ([4, 5].includes(dg)) {
                this.formData.groupType = 3;
                this.formData.centerGroupType = dg - 3;
              } else {
                this.formData.groupType = dg - 1;
              }
              this.changeNetwork(dn.id, true);
            } else if (dg === 7) {
              this.formData.reminderMode = REMINDER_MODE_MAP.NOT_HANDLE;
            } else if (dg === 8) {
              this.formData.reminderModeType = [335, 336].includes(this.formData.upgradeNetworkTypeId) ? 2 : 3
              this.upgradeNetwork = da.name || '';
              this.formData.reminderMode = REMINDER_MODE_MAP.NOT_HANDLE;
              this.formData.networkId = da.id;
              this.formData.agentAreaNetwork = da;
            } else if (dg === 9) {
              this.formData.processingMode = 2;
              this.formData.groupType = 3;
              this.formData.centerGroupType = 3;
              this.changeNetwork(dn.id, true);
            }
          }
          this.judgmentVip(); // 触发组别change事件
          this.$nextTick(() => {
            this.$refs.form.validateField('customerPhone');
            if (!this.isUpgrade) {
              if (data.workOrderDetail && data.workOrderDetail.problemDescription) {
                this.formData.labelList = []
                this.problemDescriptionInnerHTML = this.formData.problemDescription || ''
                this.$refs.labelField?.write(this.formData.problemDescription || '')
              } else if (!(this.formData.labelList && this.formData.labelList.length > 0)) {
                this.$refs.labelField?.write(this.formData.problemDescription || '')
              }
            }
          })
        } else {
          this.formData.isProject = null;
        }
      });
    },
    /**
     * 声通电话接听状态赋值操作
     */
    setCustomerPhone() {
      // 400来电 来电号码 展示当前来电号码
      if (this.onState) {
        this.formData.customerPhone = this.sensePhone;
        this.hasManualOperation = false;
        console.log('111111', 'setCustomerPhone', this.formData.customerPhone)
        this.formData.callBackPhone = this.sensePhone;
      }
    },
    // 选择网点
    changeNetwork(val, isFirstLoad) {
      // 字符串容错
      val = val && val - '';
      const { code = '', id = '', name = '', typeId = '' } =
        this.networkOptions.find((item) => item.id === val) || {};
      console.log(code, id, name, typeId);
      this.formData.networkId = id;
      this.formData.acceptNetworkCode = code;
      this.formData.acceptNetworkId = id;
      this.formData.acceptNetworkName = name;
      this.formData.acceptNetworkTypeId = typeId;
      // 转责任单网点
      if (
        (this.defaultNetwork.code === code &&
          this.defaultNetwork.id === id &&
          this.defaultNetwork.name === name &&
          this.defaultNetwork.typeId === typeId) ||
        isFirstLoad
      ) {
        this.formData.transferNetworkId = this.transferNetwork.id;
        this.formData.transferNetworkCode = this.transferNetwork.code;
        this.formData.transferNetworkName = this.transferNetwork.name;
        this.formData.transferNetworkTypeId = this.transferNetwork.typeId;
      } else {
        this.formData.transferNetworkId = id;
        this.formData.transferNetworkCode = code;
        this.formData.transferNetworkName = name;
        this.formData.transferNetworkTypeId = typeId;
      }
      console.log('defaultNetwork', this.defaultNetwork, this.formData);
    },
    beforeSubmit() {
      if (this.formData.secondTypeName === '下单') {
        // 运行 验证
        this.$refs.orderInfoForm.submitForm();
      }
      this.handlingOpinionsMsg = ''; // 校验文字置空
      this.problemDescriptionStr = ''; // 问题描述校验置空
    },
    // 取缓存的号码和页面号码做对比，一致就新增来访记录
    async getUuidPhone() {
      const { customerPhone, waybillNo } = this.formData;
      const { phone, uuid } = JSON.parse(localStorage.getItem('uuidObj')) || {};
      if (this.noPhoneBar || !customerPhone || !waybillNo || !phone) return;
      if (customerPhone === phone) {
        this.formData.soundRecordId = uuid || '';
        await this.getStorages(1, uuid);
      } else {
        this.formData.soundRecordId = '';
      }
    },
    /**
     * 触发电话条
     */
    triggerPhoneBar() {
      if (this.isTelephoneBar) {
        this.$refs[this.isXmPhone ? 'miSoft' : 'soft']?.setready();
      }
    },
    // 提交表单 (录单或催单)
    async saveSubmit() {
      // 重置国际件查询状态
      this.storageType = true;
      this.loading = true;
      const handlingOpinionsVaildate = await this.getHandlingOpinionsMsg(this.formData.handlingOpinions);
      let problemDescriptionVaildate = false
      if (!this.formData.isProject && !this.isUpgrade) {
        // 第二个入参为校验文字
        problemDescriptionVaildate = await this.getHandlingOpinionsMsg(this.formData.problemDescription, 'problemDescriptionStr');
      }
      if (!(this.isService && this.formData.showGraySwitch && this.formData.processingMode === 1) && (problemDescriptionVaildate || handlingOpinionsVaildate)) {
        this.$refs.form.validateField('handlingOpinions');
        this.$refs.form.validateField('problemDescription'); // 重新触发处理意见校验
        this.loading = false;
        return;
      }
      // const oldPathList = this.formData.pathList
      // this.formData.pathList = this.formData.pathList?.map(item => item.path) ?? []
      await this.getUuidPhone();
      // 自研平台录单获取对应会话数据
      const targetSession =
        ['imService', 'imServiceNew'].includes(this.$route.name) &&
        (this.imStorage.imUserList || []).find((item) => item.isSelected);
      if (targetSession) {
        this.formData.sessionId = targetSession.sessionId;
      }
      const iframes = document.getElementsByTagName('iframe');
      // 催单 / 升级
      if (this.isUpgrade) {
        const { reminderMode } = this.formData;
        const keys = {
          1: 2, // 暂不处理
          2: 1, // 催单
          3: 3 // 升级
        };
        this.formData.workOrderId = this.formData.id;
        this.formData.type = keys[reminderMode];
        this.loading = true;
        const params = { ...this.formData };
        delete params.showUrgentLabel;
        this.COM_HTTP.reqReminder(params)
          .then(({ code, msg }) => {
            this.loading = false;
            if (code === RESPONSE_CODE.SUCCESS) {
              this.resetFn();
              this.$message.success(msg);
              // 通话条触发
              this.triggerPhoneBar();
              for (const ele of iframes) {
                ele?.contentWindow.postMessage(targetSession?.sessionId, '*');
              }
              return;
            } else {
              this.$message.warning(msg);
              // this.formData.pathList = oldPathList
            }
          })
          .catch(() => {
            this.loading = false;
          });
        return;
      }
      const reqData = {
        workOrder: {
          ...this.formData
        }
      };
      delete reqData.workOrder.showUrgentLabel;
      if (this.formData.secondTypeName === '下单') {
        // 判断下单表格是否已校验完毕
        const res = await this.$refs.orderInfoForm.submitForm();
        if (!res) {
          return;
        }
        // 下单需设置默认值
        reqData.order = {
          from: 12,
          paymentModeCode: 'PP_CASH',
          sendName: '上门取件',
          packageTotalWeight: 1,
          packageChargeWeight: 1,
          packageNumber: 1,
          // paidModeCode: '01',
          sendCode: '01',
          needDispatch: 1,
          signSmsNotify: 0,
          senderSmsNotify: 0,
          dispatchCode: '03',
          dispatchName: '派送上门',
          expressTypeCode: 'EZ',
          ...res
        };
        if (targetSession) {
          reqData.order.sessionId = targetSession.sessionId;
        }
      }
      // 关闭 使用登陆网点
      if (
        [1, 2, 3, 4, 5].includes(this.defaultGroup) &&
        this.formData.processingMode === 1
      ) {
        const { networkId, networkCode, networkName, networkType } = this.user;
        reqData.workOrder.acceptNetworkCode = networkCode;
        reqData.workOrder.acceptNetworkId = networkId;
        reqData.workOrder.acceptNetworkName = networkName;
        reqData.workOrder.acceptNetworkTypeId = networkType;
      }
      this.loading = true;
      const group = {
        callCenter: 1,
        imOnline: 2,
        tiktokTable: 2,
        imService: 2,
        imServiceNew: 2
      };
      reqData.workOrder.recordGroup = group[this.$route.name];
      reqData.workOrder.historyType = this.isAll ? 2 : 1;
      // 接口传值是否是bs
      reqData.workOrder.isBs = this.formData.bsType;
      if (this.ifTransferOrder && !this.isHqGroup) {
        // 转单,处理意见拼上客户地址
        const { processingMode, handlingOpinions } = this.formData;
        const str1 = `客户地址：${this.formData?.addressName}${this.customerAddressData.details}；`;
        const str2 = processingMode === 1 ? handlingOpinions : '';
        reqData.workOrder.handlingOpinions = str1 + str2;
      }
      // 区分在线热线
      const apiSave = this.isService ? 'saveByOnline' : 'saveByHotline';
      if (this.imService && reqData.showGraySwitch && reqData.processingMode === 1) {
        reqData.workOrder.handlingOpinions = ''
      }
      this.COM_HTTP[apiSave](reqData)
        .then(({ code, msg }) => {
          this.loading = false;
          if (code === RESPONSE_CODE.SUCCESS) {
            this.resetFn();
            this.$message.success(this.$lang('录单保存成功！'));
            // 电话条 工单提交,调用状态就绪方法
            this.triggerPhoneBar();
            for (const ele of iframes) {
              ele?.contentWindow.postMessage(targetSession?.sessionId, '*');
            }
            return;
          }
          this.$message.warning(msg);
        })
        .catch(() => {
          this.loading = false;
        });
    },
    resetFn() {
      return new Promise((resolve) => {
        this.orderSourceName = ''; // 运单号来源清空
        this.customerAddress = ''; // 来电归属清空
        this.customerTagList = []; // 标签清空
        this.questionList = [];
        this.descriptionList = []
        this.problemDescriptionInnerHTML = ''
        this.typeReceiver = {}
        this.typeReceiverAddressHandler({})
        this.formData.typeReceiverDetailedAddress = ''
        this.isOpinionChange = false;
        this.isChangeOpinions = false;
        this.$refs.form.resetForm();
        this.waybillVisible = false;
        if (this.$refs.orderInfoForm && this.$refs.orderInfoForm.resetFields) {
          this.$refs.orderInfoForm.resetFields();
        }
        this.$nextTick(() => {
          this.defaultGroup = 1;
          this.formData = getOriginForm();
          this.$emit('waybillNo', '');
          this.formData.memberType = this.memberType;
          this.checkWaybillExist();
          this.$bus.$emit('getOrderId', '');
          this.addressInitData = {};
          this.keywordList = [];
          this.$refs.labelField?.reset()
          setTimeout(() => {
            const select =
              this.firstTypeList.find((o) => o.name === '催查件') ||
              this.firstTypeList?.find((o) => o.code === '20');
            this.formData.firstType = select.id;
            this.changeFirstType(select.id);
            this.orderTip = ''; // 订单提示
            this.cancelExplain = ''; // 订单取消原因
            resolve();
          }, 100);
        });
      });
    },
    searchFn() {
      const { customerPhone } = this.formData;
      if (
        this.isUpgrade ||
        this.formData.secondTypeName === '下单' ||
        !PHONE_REGEX.test(customerPhone)
      ) {
        return;
      }
      if (customerPhone && (customerPhone + '').trim()) {
        this.$refs.waybillDialog.show(customerPhone);
      }
    },
    // 获取声通电话条配置
    getServiceStaff() {
      console.log(this.user);
      RecordSheet.reqServiceStaff({ code: this.user.code }).then((res) => {
        // todo 连接电话条的分机号和声通技能组
        const { code, msg, data } = res;
        if (code === RESPONSE_CODE.SUCCESS) {
          this.softPhoneObj = data || {};
          this.$emit('softPhoneObj', this.softPhoneObj)
          return;
        }
        this.$message.warning(msg);
      });
    },
    setScreenWidth() {
      this.screenWidth = document.body.offsetWidth;
    },
    /**
     * 获取当前会话状态 判断是否是通话接待状态
     */
    async getCheckStatus(num) {
      // 如果有400权限
      // 请求声通接口查询是否正在通话中
      if (this.isService && this.formData.customerCode) {
        // 如果有在线客服权限  // 请求在线客服状态是否在会话
        const { data, code, msg } = await RecordSheet.getSessionId({
          waybillNo: this.formData.waybillNo,
          userCode: this.formData.customerCode
        });
        if (code === RESPONSE_CODE.SUCCESS) {
          data.sessionId && this.getStorages(2, data.sessionId);
        } else {
          this.$message.error(msg);
        }
      }
    },
    /**
     * 存储来电记录
     */
    async getStorages(type, id) {
      const { waybillNo, customerType, customerName, customerPhone } = this.formData;
      const params = {
        waybillNo: waybillNo,
        callPhone: this.onState ? this.sensePhone : customerPhone, // 来电号码 判断是否是声通电话进来记录
        callPerson: customerName, // 来访对象
        callFrom: customerType, // 来电方
        callType: type, // 进线方式(1.热线电话 2.在线客服)
        sessionId: id // 在线客服取sessionId  400 取当前电话Call_ID / uuid
      };
      const { code, msg } = await RecordSheet.addCallRecord(params);
      if (code !== RESPONSE_CODE.SUCCESS) {
        this.$message.error(msg);
      }
    },
    /**
     * 记录来电回电手机号码日志
     * customerPhone 来电号码
     * callBackPhone 回电号码
     * waybillNo 运单号
     * callType 通话状态(1.通话中 2.未通话)
     * channel 渠道(1.jms录单页面 2.jms在线客服 3.外包呼叫中心 4.外包IM在线 5.抖音工作台)
     * inComingLineType 1.电话进线 2.来电号码更改 3.回电号码更改
     */
    async setTheLog(inComingLineType) {
      const { customerPhone, callBackPhone, waybillNo } = this.formData;
      if (waybillNo) {
        const params = {
          customerPhone,
          callBackPhone,
          waybillNo,
          callType: this.onState ? '1' : '2',
          channel: this.channel,
          extensionNum: this.$refs.soft ? this.$refs.soft.extno : '',
          inComingLineType
        };
        const { code, msg } = await RecordSheet.phoneRecord(params);
        if (code !== RESPONSE_CODE.SUCCESS) {
          this.$message.error(msg);
        }
      }
    },
    /**
     * 手机号码校验
     */
    phoneExp(value) {
      return !(value && (!PHONE_REGEX.test(value) || PHONE_REGEX2.test(value)));
    },
    /**
     * 回电号码校验
     */
    callBackPhoneExp(value) {
      return !(value && (!PHONE_REGEX3.test(value) || PHONE_REGEX2.test(value)));
    },
    callBackPhone(rule, value, callback) {
      if (value && (!PHONE_REGEX3.test(value) || PHONE_REGEX2.test(value))) {
        callback(new Error(this.$lang('请输入正确的回电号码')));
      }
    },
    // 订单规则校验
    orderExp(rule, value, callback) {
      if (value && !ORDER_RULE_REGEX.test(value)) {
        callback(new Error(this.$lang('请输入正确的订单号')));
      } else {
        value && this.debounceOrder();
        callback();
      }
    },
    // 订单查询防抖
    checkOrderExist() {
      // 订单号验证完成去请求数据
      this.getInfoByInput();
      // 订单号请求基础信息
      this.getWaybillDetail();
    },
    // 请求运单/订单信息
    async getWaybillDetail() {
      try {
        const { waybillNo, orderId } = this.formData;
        if (!waybillNo && !orderId) return;
        let reqPool = 'getWaybillDetail';
        let params = waybillNo;
        if (this.isRushTake) {
          reqPool = 'getOmsOrderById';
          params = orderId;
          this.orderTip = '';
          this.cancelExplain = '';
        }
        const { data, code, msg } = await RecordSheet[reqPool](params);
        if (code === RESPONSE_CODE.SUCCESS) {
          // 基础信息为空时 走查询Bs基础信息  进行回填
          if (!data?.length && !this.isRushTake) {
            return this.getBsWaybillDetail(waybillNo);
          }
          let result = '';
          if (this.isRushTake) {
            result = data;
            this.orderTip = result?.orderStatusName || '';
            this.cancelExplain = result?.cancelExplain || '';
          } else {
            result = data && data[0] ? data[0] : {};
            this.pickUpNetworkName = result.pickUpNetworkName || '';
            this.$refs['form'].validateField('waybillNo');
            this.orderSourceName = result.orderSourceName || '';
          }
          this.setWaybill(result);
          // 存储基础信息留作对比手机号码默认选择寄件收件人
          this.storageBasicInfo = result;
          // 下单新加参数 当前接口返回
          this.formData.userCode = result.customerCode || '';
          this.formData.userName = result.customerName || '';
          // 触发事件传递订单来源编码
          this.$emit('orderSourceCode', result.orderSourceCode || '');
        } else {
          this.$message.error(msg);
        }
      } catch (error) {
        console.log(error);
      }
    },
    // 180天数据时效数据
    async getPrescription(waybillNo = '') {
      const { data, code, msg } = await this.COM_HTTP.getSecondType({
        id: this.formData.firstTypeId,
        waybillNo: waybillNo || this.formData.waybillNo,
        historyType: this.isAll ? 2 : 1,
        channelName: this.channelName
      });
      if (code === RESPONSE_CODE.SUCCESS) {
        const {
          currentDuration,
          estimateDuration,
          transportationStatus,
          isPrescription
        } = data || {};
        this.prescriptionData = {
          currentDuration,
          estimateDuration,
          transportationStatus,
          isPrescription
        };
        this.$emit('prescriptionData', this.prescriptionData);
      } else {
        this.$message.error(this.$lang(msg));
      }
    },
    // 根据手机号码查询订单信息
    async queryOrderPhone() {
      const { orderId, customerPhone } = this.formData;
      if (
        !(this.isRushTake && !orderId && customerPhone && this.phoneExp(customerPhone))
      ) {
        return;
      }
      try {
        const { code, data } = await RecordSheet.queryOrderPhone({
          phone: customerPhone
        });
        if (code === RESPONSE_CODE.SUCCESS) {
          const { id } = data;
          this.formData.orderId = id || '';
          id && this.$refs['form'].validateField('orderId');
        }
      } catch (error) {
        console.log(error);
      }
    },
    // 请求是否为总部vip组
    async requestIsHqVip() {
      try {
        const { data } = await RecordSheet.reqIsHQVIP();
        this.hqVip = data;
      } catch (error) {
        console.log(error);
      }
    },
    /**
     * 转单选中判断是否是vip工单组
     * 为总部vip时data为true   groupType默认选中4  其他禁用
     */
    judgmentVip() {
      if (this.hqVip && this.formData.memberType === 1) {
        this.formData.groupType = 4;
        this.handleChangeGroupType();
      }
    },
    changeOpinion() {
      this.isOpinionChange = true;
    },
    /**
     * 客户属性
     */
    customerTypeInput() {
      this.$refs['form'].validateField('customerType');
    },
    // 获取单号是否为集运仓件
    async getConsolidation(val) {
      if (WAYBILL_NO_REGEX_UAT) {
        RecordSheet.reqConsolidation(val).then(({ data }) => {
          this.isConsolidation = data;
        });
      }
    },
    // 问题描述校验
    problemDescriptionValidate(rule, value, callback) {
      if (this.formData.isProject) {
        return callback()
      }
      const str = this.formData.problemDescription
      this.formData.labelList = [...new Set(this.formData.labelList)]
      // this.formData.labelList?.forEach(item => {
      //   str = str.replace(item, '')
      // })
      if (!str) {
        callback(new Error(this.$lang('请输入')))
      } else {
        // this.formData.problemDescription = str
        callback()
      }
    },
    // 判断快递是否在菜鸟
    async checkCainiaoStation() {
      this.isCainiaoStation = true
      const { data } = await RecordSheet.checkCainiaoStation({ billCode: this.formData.waybillNo }).catch(() => { this.isCainiaoStation = false });
      this.isCainiaoStation = data
    },
    // 异常客服编号提示
    // async getCustomerExc(waybillNo) {
    //   this.COM_HTTP.getCustomerExc(waybillNo).then(({ data }) => {
    //     this.customerExcList = { ...data };
    //   });
    // }
    async handleOrderSuggest() {
      const { waybillNo, customerPhone, customerName } = this.formData
      const { sessionId } = this.customerInfo
      if (sessionId) {
        this.dialogOrderSuggestLoading = true
        try {
          const { data, code } = await RecordSheet.getSessionWorkOrderSuggest({
            sessionId,
            waybillNo,
            callPhone: customerPhone,
            customerName
          })
          if (code === RESPONSE_CODE.SUCCESS) {
            if (data && data?.finished) {
              this.setOrderSuggest(data)
            }
          }
        } catch (err) {
          console.log(err)
        } finally {
          this.dialogOrderSuggestLoading = false
        }
      }
    },
    // 是否显示工单小结
    async workOrderEnable() {
      const { data } = await RecordSheet.getSubtotalWorkOrderEnable()
      if (data && data === 1) {
        this.isWorkOrderEnable = true
      }
    },
    setOrderSuggest(obj) {
      const { recFirstTypeId, recSecondTypeName, recProblemDesc, callPhone, identity, customerName, aiReturnTime, graySwitch, customerGender } = obj
      const isAiReturn = graySwitch && aiReturnTime >= this.formData.timestamp
      this.formData.isAiStatus = true
      this.isAiSetType = true // 标记为通过录单小助手设置的类型
      if (isAiReturn || !graySwitch) {
        if (recFirstTypeId) {
          this.changeFirstType(recFirstTypeId, true, recSecondTypeName, recProblemDesc)
        } else {
          this.changeFirstType(this.formData.firstTypeId, true, this.formData.secondTypeName, recProblemDesc)
        }
        if (recProblemDesc) {
          this.formData.problemDescription = recProblemDesc
        }
        if (identity && identity !== this.formData.customerType) {
          this.formData.customerType = identity
        }
        if (callPhone && callPhone !== this.formData.customerPhone) {
          this.formData.customerPhone = callPhone
          this.hasManualOperation = false;
          console.log('111111', 'setOrderSuggest', this.formData.customerPhone)
        }
        if (customerName && customerName !== this.formData.customerName) {
          this.formData.customerName = customerName
        }
        if (customerName && customerName !== this.formData.callBackName) {
          const sex = (customerGender || this.formData.customerSex) === 1 ? '先生' : '女士'
          this.formData.callBackName = customerName + sex
        }
        if (callPhone && callPhone !== this.formData.callBackPhone) {
          const value = callPhone.replace(/\s/g, '');
          this.callBackPhoneExp(value) && this.setTheLog('3');
          this.formData.callBackPhone = callPhone
        }
        if (customerGender && customerGender !== this.formData.customerSex) {
          this.formData.customerSex = customerGender
        }
      } else if (!this.formData.secondTypeName && recFirstTypeId && recSecondTypeName) {
        this.changeFirstType(recFirstTypeId, true, recSecondTypeName, recProblemDesc)
      } else if (!this.secondTypeList.length || (this.secondTypeList[0] && this.secondTypeList[0].firstId !== this.formData.firstTypeId)) {
        this.changeFirstType(this.formData.firstTypeId, true, this.formData.secondTypeName, this.formData.problemDescription)
      }
    },
    // 设置时间戳
    setTimeStamp(val) {
      this.formData.timestamp = val || new Date().getTime()
    },
    handleChangeReminderModeType() {
      const networkIds = this.networkGroup.find(item => item.groupType === this.formData.reminderModeType)?.networks || []
      const { agentAreaNetwork } = this.formData
      this.upgradeNetwork = networkIds?.[0].name || ''
      this.formData.upgradeNetworkId = networkIds?.[0]?.id || ''
      if (this.formData.reminderModeType === 2) {
        this.upgradeNetwork = agentAreaNetwork?.name || networkIds?.[0].name || ''
        this.formData.upgradeNetworkId = agentAreaNetwork?.id || networkIds?.[0]?.id || ''
      }
    },
    handleChangeProcessingModeType() {
      console.log(this.formData, 'processingMode>>>')
    }
  },
  computed: {
    ...mapGetters({
      imStorage: 'imStorage'
    }),
    // 是否禁用来电号码编辑（合并原有isReminder逻辑和新进线渠道逻辑）
    isCustomerPhoneDisabled() {
      console.log('111111', 'hasManualOperation', this.hasManualOperation)
      // 1. 保持原有isReminder逻辑
      if (this.isReminder) {
        return true;
      }
      // 2. 如果用户手动操作过输入框，允许编辑
      if (this.hasManualOperation) {
        return false;
      }
      // 当时在线的时候-- 进线为紫荆山不触发置灰
      if (this.$route.name === 'imService') {
        // 3. 紫金山和紫金山-逆向渠道都可以编辑
        const tikTokChannels = ['tikTok', 'tikToknixiang'];
        if (tikTokChannels.includes(this.formData.onlineChannelSourceCode)) {
          return false;
        }
      }
      // 4. 非紫金山渠道：若是带着来访对象号码（符合手机号正则并且是明文状态）进线，则置灰不允许编辑
      // 检查是否带有来访对象号码且符合手机号正则
      const phone = this.formData.customerPhone;
      if (phone && PHONE_REGEX.test(phone)) {
        return true; // 自有渠道带号码进线，置灰不允许编辑
      }
      return false;
    },
    // 是否展示收货偏好
    showShippingPreference() {
      if (this.$route.name !== 'callCenter') return true
      const { receiverMobilePhone } = this.baseOrderInfo || {}
      const { customerPhone } = this.formData
      // 收件人手机号与来电号码前三后四相同
      if (!receiverMobilePhone || !customerPhone || !PHONE_REGEX.test(customerPhone)) return false
      const receiverPrefix = receiverMobilePhone.slice(0, 3)
      const receiverSuffix = receiverMobilePhone.slice(-4)
      const customerPrefix = customerPhone.slice(0, 3)
      const customerSuffix = customerPhone.slice(-4)
      return receiverPrefix === customerPrefix && receiverSuffix === customerSuffix
    },
    // 在线渠道=》紫金山-逆向
    tikTokReverse() {
      return this.formData.onlineChannelSourceCode === 'tikToknixiang'
    },
    // 桃花岛逆向无单号催取件
    duoduonixiang() {
      const { onlineChannelSourceCode, firstTypeCode, secondTypeCode, waybillNo } = this.formData
      return !waybillNo && onlineChannelSourceCode === 'duoduonixiang' && firstTypeCode == '21' && secondTypeCode == '2008'
    },
    // 平台催单
    isProject() {
      return this.formData.isProject;
    },
    isHqVip() {
      return this.memberType === 1 && this.hqVip;
    },
    // 是否禁用重发取件码按钮
    isDisabledResend() {
      const cainiaoStationVal = ((this.isCainiaoStation && PHONE_REGEX.test(this.formData.customerPhone)) || !this.isCainiaoStation)
      return (
        this.formData.waybillNo && this.waybillExist && this.keywordList.length !== 0 && cainiaoStationVal
      );
    },
    // 判断大屏
    isMax() {
      return this.screenWidth > 1500;
    },
    /**
     * 是否有通话条
     * 1、玄米 2、263
     */
    isTelephoneBar() {
      return (
        !this.noPhoneBar &&
        this.softPhoneObj.seatExtensionNumber &&
        (this.isXmPhone || this.isStPhone)
      );
    },
    /**
     * 炫米电话条
     */
    isXmPhone() {
      return this.softPhoneObj.telephoneType === 2;
    },
    /**
     * 声通电话条
     */
    isStPhone() {
      return this.softPhoneObj.telephoneType === 1;
    },
    // 工单类型是否为下单 （为下单需要收件人地址为非必填）
    isDisabledAddress() {
      return (
        this.formData.secondTypeName === '下单' || this.formData.firstTypeName === '咨询'
      );
    },
    isPlaceOrder() {
      return this.formData.secondTypeName === '下单';
    },
    // 处理模式禁用 => 运单不存在 || 没有运单号 || 二级类型为无转单对象
    modeDisabled() {
      // 当为问题件时默认可以转单，不用走其他逻辑
      if (this.isProblemType === 1) return false;
      // 当接口返回是bs 单号状态  默认走bs逻辑
      if (this.formData.bsType && this.immortalTrailList.length !== 0) return false;
      // 是否是订单查询
      if (this.isRushTake) return false;
      // 忽略物流轨迹扫描网点为空和问题件扫描
      const filterTrackingList = this.keywordList?.filter(
        (item) => item.scanNetworkName && !['问题件扫描'].includes(item.scanTypeName)
      );
      // 取最新一条物流轨迹
      const firstTracking = filterTrackingList[0] || {};
      // 二级类型配置转单责任方为签收网点，且最新物流轨迹扫描类型不为“出库扫描”，“入库扫描”，“签收扫描”时禁用转单
      const isDisabled =
        this.transferOrderOwner === 6 &&
        !['出库扫描', '入库扫描', '快件签收'].includes(firstTracking.scanTypeName);
      // 二级类型配置转单责任方为超时效转单，且运单状态为默认关闭时turnSingleFlag
      const turnSingleFlag = this.transferOrderOwner === 8 && this.defaultGroup === 1;
      // 无单转单
      if (this.isVisit) return false;
      if ((this.ifTransferOrder || this.isOtherType) && this.addressReqNetwork) return false;
      return (
        (!this.waybillExist && !this.pickUpNetworkName) ||
        !this.formData.waybillNo ||
        this.transferOrderOwner === 4 ||
        isDisabled ||
        turnSingleFlag
      );
    },
    // 是否为总部
    isHQ() {
      return this.user.networkType === CONST_TYPE['NT_HEADQUARTERS'];
    },
    // 是否是网点
    isNet() {
      return this.user.networkType === CONST_TYPE['NT_FIRST_LEVEL'];
    },
    // 是否是中心
    isCenter() {
      return this.user.networkType === CONST_TYPE['NT_CENTER'];
    },
    // 是否为转单
    isTurn() {
      return this.formData.processingMode === 2;
    },
    // 是否为催单（催单只能修改处理意见）
    isReminder() {
      return [REMINDER_MODE_MAP.NOT_HANDLE, REMINDER_MODE_MAP.REMINDER].includes(
        this.formData.reminderMode
      );
    },
    // 是否为暂不处理 / 催单 / 升级
    isUpgrade() {
      return (
        this.isReminder ||
        ([7, 8].includes(this.defaultGroup) &&
          this.formData.reminderMode === REMINDER_MODE_MAP.UPGRADE)
      );
    },
    networkOptions() {
      const item =
        this.networkGroup.find((o) => o.groupType === this.formData.groupType) || {};
      return item.networks || [];
    },
    // 百世录单判断条件 是否是百世
    isBsType() {
      return this.formData.bsType && this.defaultGroup === 9;
    },
    // 催取件
    isRushTake({ formData }) {
      return (
        this.formData.secondTypeCode === '2008'
      );
    },
    // 二级类型为外部来访
    isVisit() {
      return this.formData.secondTypeCode === '2005'
    },
    // 是否无单转单
    // 运单号为空，或校验不通过，noWaybillTransfer：配置为是
    ifTransferOrder() {
      const { secondTypeCode = '', noWaybillTransfer, waybillNo } = this.formData;
      const excludeCode = !['2008', '2001'].includes(secondTypeCode)// 催取件 下单时 不生效
      const hasWaybillNo = !waybillNo || (!this.waybillExist && this.keywordList.length === 0 && !this.pickUpNetworkName)
      return excludeCode && noWaybillTransfer === 1 && hasWaybillNo
    },
    // 是否无单转单组别为总部组
    isHqGroup() {
      return this.formData.noWaybillTransferType === 1
    },
    // 二级类型是否为其他
    isOtherType() {
      return this.formData.secondTypeCode === '2006'
    },
    // 问题描述标签展示
    problemDescriptionLabel() {
      return this.descriptionList.length
    },
    aiLost() { // 点击录单  并且直接成 一二级问题类型为 投诉-- 遗失或者服务态度 （手动不算）
      return this.switchDamaged && this.isAiSetType && this.formData.firstType === '288990230709563421' && ['757890625986213434','288990230940250158'].includes(this.formData.secondTypeId)
    },
    option() {
      const that = this;
      const { responsibleNetworkCode, responsibleNetworkName } = this.formData
      const responsibleDic = responsibleNetworkCode ? [{ code: responsibleNetworkCode, name: responsibleNetworkName }] : []
      return {
        emptyBtn: false,
        group: [
          {
            label: '基本信息', //  @wait (附件大小不超出3M，支持格式PNG/JPG/GIF/ZIP)
            prop: 'baceData',
            column: [
              {
                label: '运单号',
                prop: 'waybillNo',
                placeholder: '请输入',
                isSuccesslabel: this.orderSourceName,
                valueWidth: '160px',
                fetchSuggestions: true, // 新增
                // rules: [RULES.required],
                rules: [
                  { validator: that.validatorWaybill, trigger: ['change', 'blur'] }
                ],
                disabled: that.waybillVisible, // 催取件状态禁用
                maxlength: 15,
                block: !!this.formData.isProject,
                blur: ({ value }) => {
                  if (value === '') {
                    that.storageType = true;
                    that.orderSourceName = '';
                  }
                },
                change: ({ value }) => {
                  if (value === '') {
                    this.formData.customerPhone = '';
                    this.hasManualOperation = false;
                    that.storageType = true;
                    that.secondTypeList = that.secondTypeList.map((o) => {
                      o.isDisabled = false;
                      return o;
                    });
                  }
                  that.waybillExist = false;
                  that.formData.isProject = null;
                  // that.customerExcList = {};
                  that.isCainiaoStation = false
                  that.debounceFn(value);
                }
              },
              // {
              //   label: '',
              //   prop: 'waybillNoTip',
              //   slot: true
              // },
              // // 异常客服编号提示
              // {
              //   label: '',
              //   prop: 'waybillNoTipTwo',
              //   slot: true
              // },
              {
                label: '来电号码',
                prop: 'customerPhone',
                isSuccesslabel: this.customerAddress,
                display: !this.formData.isProject, // TODO
                span: 24,
                // 判断是否是55百世单号 不去校验
                // 禁用不做校验
                rules: !that.isUpgrade ? [
                  RULES.required,
                  {
                    validator(rule, value, callback) {
                      console.log('2348>>>>')
                      if (
                        value &&
                        (!PHONE_REGEX.test(value) || PHONE_REGEX2.test(value))
                      ) {
                        console.log(this.customerTagList);
                        that.customerTagList = [];
                        callback(new Error(that.$lang('请输入正确的联系号码')));
                      } else {
                        // 运单号校验正确 去记录状态查询权限
                        // if (that.waybillType && this.onState) {
                        //   that.getCheckStatus()
                        // }
                        value && that.getCustomerAddress(value);
                        value && that.getQueryByPhone(value);
                        // 根据手机号码获取订单信息
                        that.queryOrder();
                        callback();
                      }
                    },
                    trigger: ['change', 'blur']
                  }
                ] : []
              },
              {
                label: '来访对象',
                prop: 'customerName',
                display: !this.formData.isProject, // TODO
                disabled: that.isUpgrade,
                placeholder: '请输入',
                maxlength: 20,
                right: '10px',
                valueWidth: '120px',
                rules: [RULES.required],
                change: ({ value }) => {
                  const sex = that.formData.customerSex === 1 ? '先生' : '女士';
                  if (value) {
                    that.formData.callBackName = value + sex;
                    that.$refs.form.validateField('callBackName');
                  } else {
                    that.formData.callBackName = '';
                  }
                },
                focus: () => {
                  that.setTimeStamp()
                }
              },
              {
                label: '',
                prop: 'customerSex',
                display: !this.formData.isProject, // TODO
                right: '10px',
                type: 'radio',
                dicData: DICT.SEX,
                change: () => {
                  this.changeGender();
                }
              },
              {
                label: '',
                prop: 'customerType',
                display: !this.formData.isProject, // TODO
                right: '0',
                type: 'radio',
                disabled: that.isReminder,
                rules: [RULES.required],
                dicData: DICT.C_receiptType,
                change: () => {
                  this.customerTypeInput();
                  this.setTimeStamp()
                }
              },
              {
                label: '收件人地址',
                prop: 'receiverAreaId',
                rules: this.formData.showGraySwitch && this.isService ? [] : [
                  {
                    required:
                      !that.isDisabledAddress &&
                      !that.isUpgrade &&
                      !this.formData.isProject,
                    message: that.$lang('请选择省市区'),
                    trigger: ['blur', 'change']
                  }
                ], // TODO
                right: '10px'
              },
              {
                label: '',
                prop: 'receiverDetailedAddress',
                disabled:
                  (that.isUpgrade || that.isDisabledAddress) && !this.formData.isProject,
                rules: this.formData.showGraySwitch && this.isService ? [] : [
                  {
                    required:
                      !that.isDisabledAddress &&
                      !that.isUpgrade &&
                      !this.formData.isProject,
                    message: that.$lang('请输入详细地址'),
                    trigger: ['blur', 'change']
                  }
                ],
                placeholder: '请输入详细地址',
                change: ({ value }) => {
                  if (that.duoduonixiang) {
                    that.formData.typeReceiverDetailedAddress = value
                  }
                }
              },
              {
                label: '',
                prop: 'waybillTag',
                slot: true
              }
            ]
          },
          {
            label: '问题信息',
            prop: 'secondType',
            // groupSlot: true,
            column: [
              {
                label: '',
                prop: 'problemDescriptions',
                slot: true,
                display: that.isWorkOrderEnable && !that.isUpgrade && that.isOrderSuggest,
                bottom: '10px'
              },
              {
                label: '一级问题类型',
                prop: 'firstType',
                rules: this.isProject ? [] : [RULES.required],
                span: 24,
                height: 'auto',
                bottom: '10px'
              },
              {
                label: '二级问题类型',
                prop: 'secondTypeId',
                rules: this.isProject ? [] : [RULES.required],
                span: 24,
                height: 'auto',
                bottom: '10px'
              },
              {
                prop: 'orderForm',
                display: that.isPlaceOrder,
                height: 'auto',
                bottom: '0'
              },
              {
                label: '客户地址',
                prop: 'typeReceiverProvinceName',
                display: this.isRushTake,
                disabled: that.isUpgrade,
                rules: (!that.isUpgrade && !this.isRushTake) || that.formData.typeReceiverDetailedAddress ? [RULES.required] : []
              },
              {
                label: '',
                prop: 'typeReceiverDetailedAddress',
                display: this.isRushTake,
                disabled: that.isUpgrade,
                rules: (!that.isUpgrade && !this.isRushTake) || that.formData.typeReceiverProvinceName ? [RULES.required] : [],
                placeholder: '请输入详细地址',
                blur({ value }) {
                  that.typeReceiver.details = value
                  that.queryDataAddress('typeReceiver')
                },
                change: ({ value }) => {
                  if (that.duoduonixiang) {
                    that.formData.receiverDetailedAddress = value
                  }
                }
              },
              {
                label: '订单号',
                prop: 'orderId',
                display: that.isRushTake,
                changeRules: true,
                isRightLabel: that.orderTip,
                isBottomLabel: that.cancelExplain,
                span: 24,
                maxlength: 19,
                placeholder: '请输入订单号',
                rules: [
                  { validator: that.orderExp, trigger: ['change', 'blur'] }
                ],
                change({ value }) {
                  // that.debounceOrder(value)
                  !value && that.$bus.$emit('getOrderId', '');
                }
              },
              {
                label: '会员',
                prop: 'memberType',
                rules: [RULES.requiredOptions],
                disabled: true,
                type: 'radio',
                valueDefault: 2,
                dicData: DICT.memberTypeDict,
                span: 24
              },
              {
                label: '客户地址',
                prop: 'address',
                // rules: [
                //   {
                //     required: true,
                //     message: that.$lang('请选择省市区'),
                //     trigger: ['blur', 'change']
                //   }
                // ],
                right: '10px',
                display: that.ifTransferOrder && !this.isHqGroup
              },
              {
                label: '',
                prop: 'details',
                // rules: [
                //   {
                //     required: true,
                //     message: that.$lang('请输入详细地址'),
                //     trigger: ['blur', 'change']
                //   }
                // ],
                placeholder: '请输入详细地址',
                clearable: true,
                display: that.ifTransferOrder && !this.isHqGroup,
                change({ value }) {
                  that.customerAddressData.details = value;
                  that.addressReqNetwork = null;
                  that.queryDataAddress();
                }
              },
              {
                label: '责任方',
                prop: 'responsibleNetworkCode',
                type: 'ser_network',
                props: {
                  value: 'code',
                  label: 'name'
                },
                remoteQuery: {
                  isEntrepot: 2
                },
                dicUrl: '/bpo/workOrder/network/select/all',
                disabled: that.isUpgrade,
                selectDic: responsibleDic,
                display: that.formData.secondTypeCode === '2105' && that.formData.processingMode !== 1 && !that.isPlaceOrder,
                rules: that.isUpgrade ? '' : [RULES.required],
                change: ({ valueObj }) => {
                  const { name, id, code } = valueObj || {}
                  Object.assign(that.formData, {
                    responsibleNetworkCode: code,
                    responsibleNetworkName: name,
                    responsibleNetworkId: id
                  })
                }
              },
              {
                label: '问题描述',
                prop: 'problemDescription',
                placeholder: '请输入',
                type: 'textarea',
                minRows: that.isMax ? 3 : 2,
                maxlength: 500,
                flex: true,
                display: !this.formData.isProject,
                disabled: that.isUpgrade,
                rules: [RULES.required, { validator: this.handlingOpinionsValidate('problemDescriptionStr'), trigger: ['blur', 'change'] }, { validator: this.problemDescriptionValidate, trigger: ['blur', 'change'] }],
                showWordLimit: true,
                span: 24,
                change(obj) {
                  that.isChangeOpinions = true;
                }
              }
              // {
              //   label: '',
              //   prop: 'pathList',
              //   span: 24
              // }
            ]
          },
          {
            label: '处理',
            prop: 'handle',
            style: { marginBottom: '0' },
            column: [
              {
                label: '',
                prop: 'mode',
                block: true,
                bottom: '5px',
                span: 4
              },
              {
                label: '',
                prop: 'groupType',
                block: true,
                bottom: '5px',
                height: 'auto',
                display: (!this.isUpgrade && this.isTurn) || this.formData.reminderMode === REMINDER_MODE_MAP.UPGRADE,
                span: 8
              },
              {
                label: '催单至',
                prop: 'reminderNetworkId',
                type: 'select',
                clearable: false,
                rules: [RULES.required],
                props: {
                  label: 'name',
                  value: 'id'
                },
                disabled: true,
                display: !!this.formData.reminderNetworkId && this.formData.reminderMode === REMINDER_MODE_MAP.REMINDER,
                dicData: this.networkGroup.flatMap(({ networks }) => networks?.map(({ id, name }) => ({ id, name })) || [])
              },
              {
                label: '催单原因',
                prop: 'reminderReason',
                type: 'select',
                clearable: false,
                rules: [RULES.required],
                dicData: this.reasonOptions,
                display: this.formData.reminderMode === REMINDER_MODE_MAP.REMINDER,
                span: 24
              },
              {
                label: '',
                prop: 'networkId',
                span: 24,
                bottom: that.isMax ? '40px' : '20px',
                rules: [RULES.required],
                display:
                  (this.isTurn ||
                    this.formData.reminderMode === REMINDER_MODE_MAP.UPGRADE) &&
                  !this.formData.isProject
              },
              {
                label: '回电对象',
                prop: 'callBackName',
                rules: [RULES.required],
                placeholder: '请输入',
                maxlength: 15,
                // 处理方式为关闭或为下单的时候许隐藏回电号码，回电对象
                display: (this.isTurn || this.isUpgrade) && !this.formData.isProject,
                focus: () => {
                  that.setTimeStamp()
                }
              },
              {
                label: '回电号码',
                prop: 'callBackPhone',
                placeholder: '请输入',
                changeRules: true,
                rules: [
                  RULES.required,
                  { validator: that.callBackPhone, trigger: ['change', 'blur'] }
                ],
                maxlength: 15,
                // 处理方式为关闭或为下单的时候许隐藏回电号码，回电对象
                display: (this.isTurn || this.isUpgrade) && !this.formData.isProject,
                change: ({ value }) => {
                  value = value.replace(/\s/g, '');
                  that.formData.callBackPhone = value;
                  that.callBackPhoneExp(value) && that.setTheLog('3');
                },
                focus: () => {
                  that.setTimeStamp()
                }
              },
              {
                label: '处理意见',
                prop: 'handlingOpinions',
                placeholder: '请输入',
                type: 'textarea',
                minRows: that.isMax ? 3 : 2,
                span: 24,
                autosize: true,
                maxlength: 500,
                // 只有当处理模式为关闭或催单时才展示
                display: (this.isService && this.formData.showGraySwitch && this.formData.processingMode === 1) ? false : this.formData.processingMode === 1 || this.isUpgrade,
                rules: this.isService && this.formData.showGraySwitch && this.formData.processingMode === 1 ? [] : [
                  RULES.required,
                  {
                    validator: this.handlingOpinionsValidate(),
                    trigger: ['blur', 'change']
                  }
                ],
                showWordLimit: true
              }
            ]
          }
        ]
      };
    }
    // 异常运单
    // netAbmWaybillDisable() {
    //   const {
    //     disableWorkOrder,
    //     allowWorkorderList = []
    //   } = this.$refs.abnomalTip.netAbmWaybill;
    //   const { firstTypeId, secondTypeId } = this.formData;
    //   if (disableWorkOrder !== 2) return false; // 非限制转单
    //   const searchinfo =
    //     allowWorkorderList?.filter((item) => {
    //       return item.allowWorkorderTypeId === firstTypeId && item.id === secondTypeId;
    //     }) || [];
    //   if (!searchinfo.length) {
    //     return false;
    //   } else {
    //     return true;
    //   }
    // }
  },
  mounted() {
    console.log('111111', 'mounted')

    // 不在 在线客服/录单 不请求接口
    if (
      this.$route.name === 'imOnline' ||
      this.$route.name === 'callCenter' ||
      this.$route.name === 'tiktokTable'
    ) {
      this.getFirstType();
      !this.noPhoneBar && this.getServiceStaff();
    }
    this.workOrderEnable()
  }
};
</script>

<style lang="scss">
.record-sheet-form {
  // 百世按钮
  .bs-radio {
    margin-right: 0px;
    height: 24px;
    display: flex;
    align-items: center;
  }
  .bs-service {
    .group-content {
      > :nth-child(1) {
        // padding-right: 0px;
      }
      > :nth-child(2) {
        // padding-right: 5px;
      }
    }
  }
  .project-process-question {
    display: flex;
    box-sizing: border-box;
    flex-wrap: wrap;
    .q-list {
      // width: 80px;
      height: 24px;
      line-height: 24px;
      font-size: 12px;
      border: 1px solid #dddddd;
      border-radius: 4px;
      margin: 0 10px 10px 0;
      box-sizing: border-box;
      color: #999999;
      @include border-color("lighter");
      @include text-color("routine");
      cursor: pointer;
      position: relative;
      white-space: nowrap;
      word-break: break-all;
      text-overflow: ellipsis;
      padding: 0 10px;
      box-sizing: border-box;
      text-align: center;
      .el-icon-success {
        position: absolute;
        right: -4px;
        top: -6px;
        z-index: 100;
        overflow: none;
        font-size: 12px;
      }
    }
    .active {
      // @include base-bg-color-1();
      // border: 1px solid rgba(45,124,255,0.5);
      @include base-color("clr");
      // @include base-border-color-5();
    }
  }
  .avue-form__item--4 {
    .el-form-item__content {
      width: 200px;
    }
  }
  .customer-num {
    color: #ffffff;
    @include bg-color("brand");
    border-radius: 100%;
    /* position: absolute; */
    /* left: 160px; */
    /* top: 5px; */
    width: 25px;
    height: 25px;
    text-align: center;
    line-height: 25px;
    font-size: 12px;
    /* padding: 5px; */
    display: inline-block;
  }
  .custom-province .cp-modal {
    z-index: 99999;
  }

  .line-radio {
    margin-top: 10px;
  }
}

.record-sheet-form {
  width: 550px;
  .el-radio-group {
    display: inline-block;
  }
  .el-radio__label {
    padding-left: 4px;
    font-size: 12px;
  }
  .search-btn {
    position: absolute;
    top: 0;
    // right: 10px;
    left: 115px;
    font-size: 12px;
    cursor: pointer;
    // color: #2d7cff;
    color: $-color-brand;
  }
  .type-wrap {
    padding: 10px;
    border: 1px solid #ddd;
    border-radius: 4px;
    .no-data {
      text-align: center;
      color: #999;
    }
  }
}
@media screen and (min-width: 1500px) {
  #gateway .record-sheet-form {
    .group-item:not(.last-item) {
      margin-bottom: 40px;
    }
    .form-item {
      height: 32px;
      .label {
        line-height: 32px;
      }
      .input-box {
        min-height: 32px;
      }
      .el-input input {
        height: 32px;
        line-height: 32px;
      }
    }
    .search-btn {
      line-height: 32px;
    }
    .el-input .el-input__icon {
      line-height: 32px;
    }
    .el-input {
      height: 32px;
    }
    .line-radio {
      margin-top: 20px;
      margin-bottom: 14px;
    }
    .el-radio__label {
      line-height: 32px;
    }
  }
}

.softphone {
  padding: 3px 20px;
  box-sizing: border-box;
}
</style>
<style lang="scss" scoped>
.leftform-customer-type {
  position: relative;
  .customer-type {
    position: absolute;
    top: -6px;
    font-weight: bolder;
    font-size: 16px;
    white-space: nowrap;
    height: 36px;
  }
}
.suggest-box{
  display: flex;
}
.suggest-img{
    width:50px;
    height:50px;
    margin-right:10px;
    border-radius: 50%;
}
.suggest-content{
    flex:1;
    border:1px solid #E42E35;border-radius: 8px;padding:10px;
    i{cursor: pointer;margin-left:10px;}
     .mt12{
        margin-top:12px;
        margin-bottom:2px;
      }
      .mt26{
        margin-top:26px;
        margin-bottom:2px;
      }
}
.customer-phone {
  width: 56%;
  display: flex;
 ::v-deep .el-button--mini {
    padding: 4px 9px !important;
  }
}
.suggestBtn{
  cursor:pointer;
  color:#E42E35;
  font-size:14px;
}
.el-icon-circle-plus{
  padding-left:5px;
}
</style>
